var items = {
  "block.minecraft.acacia_button": "Boton en cacièr",
  "block.minecraft.acacia_door": "Pòrta en cacièr",
  "block.minecraft.acacia_fence": "Barralha en cacièr",
  "block.minecraft.acacia_fence_gate": "Pòrta de barralha en cacièr",
  "block.minecraft.acacia_hanging_sign": "Pancarta penjanta en cacièr",
  "block.minecraft.acacia_leaves": "Fuèlhas de cacièr",
  "block.minecraft.acacia_log": "Busca de cacièr",
  "block.minecraft.acacia_planks": "Plancas de cacièr",
  "block.minecraft.acacia_pressure_plate": "Placa de pression en cacièr",
  "block.minecraft.acacia_sapling": "Grelh de cacièr",
  "block.minecraft.acacia_shelf": "Estaudèla en cacièr",
  "block.minecraft.acacia_sign": "Pancarta en cacièr",
  "block.minecraft.acacia_slab": "Lausa de cacièr",
  "block.minecraft.acacia_stairs": "Escalièrs en cacièr",
  "block.minecraft.acacia_trapdoor": "Trapa en cacièr",
  "block.minecraft.acacia_wall_hanging_sign": "Pancarta penjanta en cacièr murala",
  "block.minecraft.acacia_wall_sign": "Pancarta en cacièr murala",
  "block.minecraft.acacia_wood": "Fusta de cacièr",
  "block.minecraft.activator_rail": "Ralh activator",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "Allium",
  "block.minecraft.amethyst_block": "Blòc d'ametista",
  "block.minecraft.amethyst_cluster": "Amàs d'ametista",
  "block.minecraft.ancient_debris": "Brigalhs antics",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Lausa d'andesita",
  "block.minecraft.andesite_stairs": "Escalièrs d'andesita",
  "block.minecraft.andesite_wall": "Muret d'andesita",
  "block.minecraft.anvil": "Enclutge",
  "block.minecraft.attached_melon_stem": "Tija de pastèca estacada",
  "block.minecraft.attached_pumpkin_stem": "Tija de coja estacada",
  "block.minecraft.azalea": "Azalèa",
  "block.minecraft.azalea_leaves": "Fuèlhas d'azalèa",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambó",
  "block.minecraft.bamboo_block": "Blòc de bambó",
  "block.minecraft.bamboo_button": "Boton en bambó",
  "block.minecraft.bamboo_door": "Pòrta en bambó",
  "block.minecraft.bamboo_fence": "Barralha en bambó",
  "block.minecraft.bamboo_fence_gate": "Pòrta de barralha en bambó",
  "block.minecraft.bamboo_hanging_sign": "Pancarta penjanta en bambó",
  "block.minecraft.bamboo_mosaic": "Mosaïc de bambó",
  "block.minecraft.bamboo_mosaic_slab": "Lausa en mosaïc de bambó",
  "block.minecraft.bamboo_mosaic_stairs": "Escalièrs en mosaïc de bambó",
  "block.minecraft.bamboo_planks": "Plancas de bambó",
  "block.minecraft.bamboo_pressure_plate": "Placa de pression en bambó",
  "block.minecraft.bamboo_sapling": "Brot de bambó",
  "block.minecraft.bamboo_shelf": "Estaudèla en bambó",
  "block.minecraft.bamboo_sign": "Pancarta en bambó",
  "block.minecraft.bamboo_slab": "Lausa en bambó",
  "block.minecraft.bamboo_stairs": "Escalièrs en bambó",
  "block.minecraft.bamboo_trapdoor": "Trapa en bambó",
  "block.minecraft.bamboo_wall_hanging_sign": "Pancarta penjanta en bambó murala",
  "block.minecraft.bamboo_wall_sign": "Pancarta en bambó murala",
  "block.minecraft.banner.base.black": "Camp negre plan",
  "block.minecraft.banner.base.blue": "Camp blau plan",
  "block.minecraft.banner.base.brown": "Camp brun plan",
  "block.minecraft.banner.base.cyan": "Camp cian plan",
  "block.minecraft.banner.base.gray": "Camp gris plan",
  "block.minecraft.banner.base.green": "Camp verd plan",
  "block.minecraft.banner.base.light_blue": "Camp blau clar plan",
  "block.minecraft.banner.base.light_gray": "Camp gris clar plan",
  "block.minecraft.banner.base.lime": "Camp lima plan",
  "block.minecraft.banner.base.magenta": "Camp magenta plan",
  "block.minecraft.banner.base.orange": "Camp irange plan",
  "block.minecraft.banner.base.pink": "Camp ròse plan",
  "block.minecraft.banner.base.purple": "Camp violet plan",
  "block.minecraft.banner.base.red": "Camp roge plan",
  "block.minecraft.banner.base.white": "Camp blanc plan",
  "block.minecraft.banner.base.yellow": "Camp jaune plan",
  "block.minecraft.banner.border.black": "Bordadura negra",
  "block.minecraft.banner.border.blue": "Bordadura blava",
  "block.minecraft.banner.border.brown": "Bordadura bruna",
  "block.minecraft.banner.border.cyan": "Bordadura cian",
  "block.minecraft.banner.border.gray": "Bordadura grisa",
  "block.minecraft.banner.border.green": "Bordadura verda",
  "block.minecraft.banner.border.light_blue": "Bordadura blau clar",
  "block.minecraft.banner.border.light_gray": "Bordadura gris clar",
  "block.minecraft.banner.border.lime": "Bordadura lima",
  "block.minecraft.banner.border.magenta": "Bordadura magenta",
  "block.minecraft.banner.border.orange": "Bordadura iranja",
  "block.minecraft.banner.border.pink": "Bordadura ròsa",
  "block.minecraft.banner.border.purple": "Bordadura violeta",
  "block.minecraft.banner.border.red": "Bordadura roja",
  "block.minecraft.banner.border.white": "Bordadura blanca",
  "block.minecraft.banner.border.yellow": "Bordadura jauna",
  "block.minecraft.banner.bricks.black": "Camp maçonat negre",
  "block.minecraft.banner.bricks.blue": "Camp maçonat blau",
  "block.minecraft.banner.bricks.brown": "Camp maçonat brun",
  "block.minecraft.banner.bricks.cyan": "Camp maçonat cian",
  "block.minecraft.banner.bricks.gray": "Camp maçonat gris",
  "block.minecraft.banner.bricks.green": "Camp maçonat verd",
  "block.minecraft.banner.bricks.light_blue": "Camp maçonat blau clar",
  "block.minecraft.banner.bricks.light_gray": "Camp maçonat gris clar",
  "block.minecraft.banner.bricks.lime": "Camp maçonat lima",
  "block.minecraft.banner.bricks.magenta": "Camp maçonat magenta",
  "block.minecraft.banner.bricks.orange": "Camp maçonat irange",
  "block.minecraft.banner.bricks.pink": "Camp maçonat ròse",
  "block.minecraft.banner.bricks.purple": "Camp maçonat violet",
  "block.minecraft.banner.bricks.red": "Camp maçonat roge",
  "block.minecraft.banner.bricks.white": "Camp maçonat blanc",
  "block.minecraft.banner.bricks.yellow": "Camp maçonat jaune",
  "block.minecraft.banner.circle.black": "Tortèu negre",
  "block.minecraft.banner.circle.blue": "Tortèu blau",
  "block.minecraft.banner.circle.brown": "Tortèu brun",
  "block.minecraft.banner.circle.cyan": "Tortèu cian",
  "block.minecraft.banner.circle.gray": "Tortèu gris",
  "block.minecraft.banner.circle.green": "Tortèu verd",
  "block.minecraft.banner.circle.light_blue": "Tortèu blau clar",
  "block.minecraft.banner.circle.light_gray": "Tortèu gris clar",
  "block.minecraft.banner.circle.lime": "Tortèu lima",
  "block.minecraft.banner.circle.magenta": "Tortèu magenta",
  "block.minecraft.banner.circle.orange": "Tortèu irange",
  "block.minecraft.banner.circle.pink": "Tortèu ròse",
  "block.minecraft.banner.circle.purple": "Tortèu violet",
  "block.minecraft.banner.circle.red": "Tortèu roge",
  "block.minecraft.banner.circle.white": "Tortèu blanc",
  "block.minecraft.banner.circle.yellow": "Tortèu jaune",
  "block.minecraft.banner.creeper.black": "Fàcia de creeper negra",
  "block.minecraft.banner.creeper.blue": "Fàcia de creeper blava",
  "block.minecraft.banner.creeper.brown": "Fàcia de creeper bruna",
  "block.minecraft.banner.creeper.cyan": "Fàcia de creeper cian",
  "block.minecraft.banner.creeper.gray": "Fàcia de creeper grisa",
  "block.minecraft.banner.creeper.green": "Fàcia de creeper verda",
  "block.minecraft.banner.creeper.light_blue": "Fàcia de creeper blau clar",
  "block.minecraft.banner.creeper.light_gray": "Fàcia de creeper gris clar",
  "block.minecraft.banner.creeper.lime": "Fàcia de creeper lima",
  "block.minecraft.banner.creeper.magenta": "Fàcia de creeper magenta",
  "block.minecraft.banner.creeper.orange": "Fàcia de creeper iranja",
  "block.minecraft.banner.creeper.pink": "Fàcia de creeper ròsa",
  "block.minecraft.banner.creeper.purple": "Fàcia de creeper violeta",
  "block.minecraft.banner.creeper.red": "Fàcia de creeper roja",
  "block.minecraft.banner.creeper.white": "Fàcia de creeper blanca",
  "block.minecraft.banner.creeper.yellow": "Fàcia de creeper jauna",
  "block.minecraft.banner.cross.black": "Sautador negre",
  "block.minecraft.banner.cross.blue": "Sautador blau",
  "block.minecraft.banner.cross.brown": "Sautador brun",
  "block.minecraft.banner.cross.cyan": "Sautador cian",
  "block.minecraft.banner.cross.gray": "Sautador gris",
  "block.minecraft.banner.cross.green": "Sautador verd",
  "block.minecraft.banner.cross.light_blue": "Sautador blau clar",
  "block.minecraft.banner.cross.light_gray": "Sautador gris car",
  "block.minecraft.banner.cross.lime": "Sautador lima",
  "block.minecraft.banner.cross.magenta": "Sautador magenta",
  "block.minecraft.banner.cross.orange": "Sautador irange",
  "block.minecraft.banner.cross.pink": "Sautador ròse",
  "block.minecraft.banner.cross.purple": "Sautador violet",
  "block.minecraft.banner.cross.red": "Sautador roge",
  "block.minecraft.banner.cross.white": "Sautador blanc",
  "block.minecraft.banner.cross.yellow": "Sautador jaune",
  "block.minecraft.banner.curly_border.black": "Bordadura endentada negra",
  "block.minecraft.banner.curly_border.blue": "Bordadura endentada blava",
  "block.minecraft.banner.curly_border.brown": "Bordadura endentada bruna",
  "block.minecraft.banner.curly_border.cyan": "Bordadura endentada cian",
  "block.minecraft.banner.curly_border.gray": "Bordadura endentada grisa",
  "block.minecraft.banner.curly_border.green": "Bordadura endentada verda",
  "block.minecraft.banner.curly_border.light_blue": "Bordadura endentada blau clar",
  "block.minecraft.banner.curly_border.light_gray": "Bordadura endentada gris clar",
  "block.minecraft.banner.curly_border.lime": "Bordadura endentada lima",
  "block.minecraft.banner.curly_border.magenta": "Bordadura endentada magenta",
  "block.minecraft.banner.curly_border.orange": "Bordadura endentada iranja",
  "block.minecraft.banner.curly_border.pink": "Bordadura endentada ròsa",
  "block.minecraft.banner.curly_border.purple": "Bordadura endentada violeta",
  "block.minecraft.banner.curly_border.red": "Bordadura endentada roja",
  "block.minecraft.banner.curly_border.white": "Bordadura endentada blanca",
  "block.minecraft.banner.curly_border.yellow": "Bordadura endentada jauna",
  "block.minecraft.banner.diagonal_left.black": "Talhat, 1èr negre",
  "block.minecraft.banner.diagonal_left.blue": "Talhat, 1èr blau",
  "block.minecraft.banner.diagonal_left.brown": "Talhat, 1èr brun",
  "block.minecraft.banner.diagonal_left.cyan": "Talhat, 1èr cian",
  "block.minecraft.banner.diagonal_left.gray": "Talhat, 1èr gris",
  "block.minecraft.banner.diagonal_left.green": "Talhat, 1èr verd",
  "block.minecraft.banner.diagonal_left.light_blue": "Talhat, 1èr blau clar",
  "block.minecraft.banner.diagonal_left.light_gray": "Talhat, 1èr gris clar",
  "block.minecraft.banner.diagonal_left.lime": "Talhat, 1èr lima",
  "block.minecraft.banner.diagonal_left.magenta": "Talhat, 1èr magenta",
  "block.minecraft.banner.diagonal_left.orange": "Talhat, 1èr irange",
  "block.minecraft.banner.diagonal_left.pink": "Talhat, 1èr ròse",
  "block.minecraft.banner.diagonal_left.purple": "Talhat, 1èr violet",
  "block.minecraft.banner.diagonal_left.red": "Talhat, 1èr roge",
  "block.minecraft.banner.diagonal_left.white": "Talhat, 1èr blanc",
  "block.minecraft.banner.diagonal_left.yellow": "Talhat, 1èr jaune",
  "block.minecraft.banner.diagonal_right.black": "Trencat, 1èr negre",
  "block.minecraft.banner.diagonal_right.blue": "Trencat, 1èr blau",
  "block.minecraft.banner.diagonal_right.brown": "Trencat, 1èr brun",
  "block.minecraft.banner.diagonal_right.cyan": "Trencat, 1èr cian",
  "block.minecraft.banner.diagonal_right.gray": "Trencat, 1èr gris",
  "block.minecraft.banner.diagonal_right.green": "Trencat, 1èr verd",
  "block.minecraft.banner.diagonal_right.light_blue": "Trencat, 1èr blau clar",
  "block.minecraft.banner.diagonal_right.light_gray": "Trencat, 1èr gris clar",
  "block.minecraft.banner.diagonal_right.lime": "Trencat, 1èr lima",
  "block.minecraft.banner.diagonal_right.magenta": "Trencat, 1èr magenta",
  "block.minecraft.banner.diagonal_right.orange": "Trencat, 1èr irange",
  "block.minecraft.banner.diagonal_right.pink": "Trencat, 1èr ròse",
  "block.minecraft.banner.diagonal_right.purple": "Trencat, 1èr violet",
  "block.minecraft.banner.diagonal_right.red": "Trencat, 1èr roge",
  "block.minecraft.banner.diagonal_right.white": "Trencat, 1èr blanc",
  "block.minecraft.banner.diagonal_right.yellow": "Trencat, 1èr jaune",
  "block.minecraft.banner.diagonal_up_left.black": "Trencat, 2nd negre",
  "block.minecraft.banner.diagonal_up_left.blue": "Trencat, 2nd blau",
  "block.minecraft.banner.diagonal_up_left.brown": "Trencat, 2nd brun",
  "block.minecraft.banner.diagonal_up_left.cyan": "Trencat, 2nd cian",
  "block.minecraft.banner.diagonal_up_left.gray": "Trencat, 2nd gris",
  "block.minecraft.banner.diagonal_up_left.green": "Trencat, 2nd verd",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Trencat, 2nd blau clar",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Trencat, 2nd gris clar",
  "block.minecraft.banner.diagonal_up_left.lime": "Trencat, 2nd lima",
  "block.minecraft.banner.diagonal_up_left.magenta": "Trencat, 2nd magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Trencat, 2nd irange",
  "block.minecraft.banner.diagonal_up_left.pink": "Trencat, 2nd ròse",
  "block.minecraft.banner.diagonal_up_left.purple": "Trencat, 2nd violet",
  "block.minecraft.banner.diagonal_up_left.red": "Trencat, 2nd roge",
  "block.minecraft.banner.diagonal_up_left.white": "Trencat, 2nd blanc",
  "block.minecraft.banner.diagonal_up_left.yellow": "Trencat, 2nd jaune",
  "block.minecraft.banner.diagonal_up_right.black": "Talhat, 2nd negre",
  "block.minecraft.banner.diagonal_up_right.blue": "Talhat, 2nd blau",
  "block.minecraft.banner.diagonal_up_right.brown": "Talhat, 2nd brun",
  "block.minecraft.banner.diagonal_up_right.cyan": "Talhat, 2nd cian",
  "block.minecraft.banner.diagonal_up_right.gray": "Talhat, 2nd gris",
  "block.minecraft.banner.diagonal_up_right.green": "Talhat, 2nd verd",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Talhat, 2nd blau clar",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Talhat, 2nd gris clar",
  "block.minecraft.banner.diagonal_up_right.lime": "Talhat, 2nd lima",
  "block.minecraft.banner.diagonal_up_right.magenta": "Talhat, 2nd magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Talhat, 2nd irange",
  "block.minecraft.banner.diagonal_up_right.pink": "Talhat, 2nd ròse",
  "block.minecraft.banner.diagonal_up_right.purple": "Talhat, 2nd violet",
  "block.minecraft.banner.diagonal_up_right.red": "Talhat, 2nd roge",
  "block.minecraft.banner.diagonal_up_right.white": "Talhat, 2nd blanc",
  "block.minecraft.banner.diagonal_up_right.yellow": "Talhat, 2nd jaune",
  "block.minecraft.banner.flow.black": "Revolum negre",
  "block.minecraft.banner.flow.blue": "Revolum blau",
  "block.minecraft.banner.flow.brown": "Revolum brun",
  "block.minecraft.banner.flow.cyan": "Revolum cian",
  "block.minecraft.banner.flow.gray": "Revolum gris",
  "block.minecraft.banner.flow.green": "Revolum verd",
  "block.minecraft.banner.flow.light_blue": "Revolum blau clar",
  "block.minecraft.banner.flow.light_gray": "Revolum gris clar",
  "block.minecraft.banner.flow.lime": "Revolum lima",
  "block.minecraft.banner.flow.magenta": "Revolum magenta",
  "block.minecraft.banner.flow.orange": "Revolum irange",
  "block.minecraft.banner.flow.pink": "Revolum ròse",
  "block.minecraft.banner.flow.purple": "Revolum violet",
  "block.minecraft.banner.flow.red": "Revolum roge",
  "block.minecraft.banner.flow.white": "Revolum blanc",
  "block.minecraft.banner.flow.yellow": "Revolum jaune",
  "block.minecraft.banner.flower.black": "Flor negra",
  "block.minecraft.banner.flower.blue": "Flor blava",
  "block.minecraft.banner.flower.brown": "Flor bruna",
  "block.minecraft.banner.flower.cyan": "Flor cian",
  "block.minecraft.banner.flower.gray": "Flor grisa",
  "block.minecraft.banner.flower.green": "Flor verda",
  "block.minecraft.banner.flower.light_blue": "Flor blau clar",
  "block.minecraft.banner.flower.light_gray": "Flor gris clar",
  "block.minecraft.banner.flower.lime": "Flor lima",
  "block.minecraft.banner.flower.magenta": "Flor magenta",
  "block.minecraft.banner.flower.orange": "Flor iranja",
  "block.minecraft.banner.flower.pink": "Flor ròsa",
  "block.minecraft.banner.flower.purple": "Flor violeta",
  "block.minecraft.banner.flower.red": "Flor roja",
  "block.minecraft.banner.flower.white": "Flor blanca",
  "block.minecraft.banner.flower.yellow": "Flor jauna",
  "block.minecraft.banner.globe.black": "Glòbe negre",
  "block.minecraft.banner.globe.blue": "Glòbe blau",
  "block.minecraft.banner.globe.brown": "Glòbe brun",
  "block.minecraft.banner.globe.cyan": "Glòbe cian",
  "block.minecraft.banner.globe.gray": "Glòbe gris",
  "block.minecraft.banner.globe.green": "Glòbe verd",
  "block.minecraft.banner.globe.light_blue": "Glòbe blau clar",
  "block.minecraft.banner.globe.light_gray": "Glòbe gris clar",
  "block.minecraft.banner.globe.lime": "Glòbe lima",
  "block.minecraft.banner.globe.magenta": "Glòbe magenta",
  "block.minecraft.banner.globe.orange": "Glòbe irange",
  "block.minecraft.banner.globe.pink": "Glòbe ròse",
  "block.minecraft.banner.globe.purple": "Glòbe violet",
  "block.minecraft.banner.globe.red": "Glòbe roge",
  "block.minecraft.banner.globe.white": "Glòbe blanc",
  "block.minecraft.banner.globe.yellow": "Glòbe jaune",
  "block.minecraft.banner.gradient.black": "Degradat negre",
  "block.minecraft.banner.gradient.blue": "Degradat blau",
  "block.minecraft.banner.gradient.brown": "Degradat brun",
  "block.minecraft.banner.gradient.cyan": "Degradat cian",
  "block.minecraft.banner.gradient.gray": "Degradat gris",
  "block.minecraft.banner.gradient.green": "Degradat verd",
  "block.minecraft.banner.gradient.light_blue": "Degradat blau clar",
  "block.minecraft.banner.gradient.light_gray": "Degradat gris clar",
  "block.minecraft.banner.gradient.lime": "Degradat lima",
  "block.minecraft.banner.gradient.magenta": "Degradat magenta",
  "block.minecraft.banner.gradient.orange": "Degradat irange",
  "block.minecraft.banner.gradient.pink": "Degradat ròse",
  "block.minecraft.banner.gradient.purple": "Degradat violet",
  "block.minecraft.banner.gradient.red": "Degradat roge",
  "block.minecraft.banner.gradient.white": "Degradat blanc",
  "block.minecraft.banner.gradient.yellow": "Degradat jaune",
  "block.minecraft.banner.gradient_up.black": "Degradat negre en poncha",
  "block.minecraft.banner.gradient_up.blue": "Degradat blau en poncha",
  "block.minecraft.banner.gradient_up.brown": "Degradat brun en poncha",
  "block.minecraft.banner.gradient_up.cyan": "Degradat cian en poncha",
  "block.minecraft.banner.gradient_up.gray": "Degradat gris en poncha",
  "block.minecraft.banner.gradient_up.green": "Degradat verd en poncha",
  "block.minecraft.banner.gradient_up.light_blue": "Degradat blau clar en poncha",
  "block.minecraft.banner.gradient_up.light_gray": "Degradat gris clar en poncha",
  "block.minecraft.banner.gradient_up.lime": "Degradat lima en poncha",
  "block.minecraft.banner.gradient_up.magenta": "Degradat magenta en poncha",
  "block.minecraft.banner.gradient_up.orange": "Degradat irange en poncha",
  "block.minecraft.banner.gradient_up.pink": "Degradat ròse en poncha",
  "block.minecraft.banner.gradient_up.purple": "Degradat violet en poncha",
  "block.minecraft.banner.gradient_up.red": "Degradat roge en poncha",
  "block.minecraft.banner.gradient_up.white": "Degradat blanc en poncha",
  "block.minecraft.banner.gradient_up.yellow": "Degradat jaune en poncha",
  "block.minecraft.banner.guster.black": "Ventorià negra",
  "block.minecraft.banner.guster.blue": "Ventorià blava",
  "block.minecraft.banner.guster.brown": "Ventorià bruna",
  "block.minecraft.banner.guster.cyan": "Ventorià cian",
  "block.minecraft.banner.guster.gray": "Ventorià grisa",
  "block.minecraft.banner.guster.green": "Ventorià verda",
  "block.minecraft.banner.guster.light_blue": "Ventorià blau clar",
  "block.minecraft.banner.guster.light_gray": "Ventorià gris clar",
  "block.minecraft.banner.guster.lime": "Ventorià lima",
  "block.minecraft.banner.guster.magenta": "Ventorià magenta",
  "block.minecraft.banner.guster.orange": "Ventorià iranja",
  "block.minecraft.banner.guster.pink": "Ventorià ròsa",
  "block.minecraft.banner.guster.purple": "Ventorià violeta",
  "block.minecraft.banner.guster.red": "Ventorià roja",
  "block.minecraft.banner.guster.white": "Ventorià blanca",
  "block.minecraft.banner.guster.yellow": "Ventorià jauna",
  "block.minecraft.banner.half_horizontal.black": "Copat, 1èr negre",
  "block.minecraft.banner.half_horizontal.blue": "Copat, 1èr blau",
  "block.minecraft.banner.half_horizontal.brown": "Copat, 1èr brun",
  "block.minecraft.banner.half_horizontal.cyan": "Copat, 1èr cian",
  "block.minecraft.banner.half_horizontal.gray": "Copat, 1èr gris",
  "block.minecraft.banner.half_horizontal.green": "Copat, 1èr verd",
  "block.minecraft.banner.half_horizontal.light_blue": "Copat, 1èr blau clar",
  "block.minecraft.banner.half_horizontal.light_gray": "Copat, 1èr gris clar",
  "block.minecraft.banner.half_horizontal.lime": "Copat, 1èr lima",
  "block.minecraft.banner.half_horizontal.magenta": "Copat, 1èr magenta",
  "block.minecraft.banner.half_horizontal.orange": "Copat, 1èr irange",
  "block.minecraft.banner.half_horizontal.pink": "Copat, 1èr ròse",
  "block.minecraft.banner.half_horizontal.purple": "Copat, 1èr violet",
  "block.minecraft.banner.half_horizontal.red": "Copat, 1èr roge",
  "block.minecraft.banner.half_horizontal.white": "Copat, 1èr blanc",
  "block.minecraft.banner.half_horizontal.yellow": "Copat, 1èr jaune",
  "block.minecraft.banner.half_horizontal_bottom.black": "Copat, 2nd negre",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Copat, 2nd blau",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Copat, 2nd brun",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Copat, 2nd cian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Copat, 2nd gris",
  "block.minecraft.banner.half_horizontal_bottom.green": "Copat, 2nd verd",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Copat, 2nd blau clar",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Copat, 2nd gris clar",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Copat, 2nd lima",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Copat, 2nd magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Copat, 2nd irange",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Copat, 2nd ròse",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Copat, 2nd violet",
  "block.minecraft.banner.half_horizontal_bottom.red": "Copat, 2nd roge",
  "block.minecraft.banner.half_horizontal_bottom.white": "Copat, 2nd blanc",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Copat, 2nd jaune",
  "block.minecraft.banner.half_vertical.black": "Partit, 1èr negre",
  "block.minecraft.banner.half_vertical.blue": "Partit, 1èr blau",
  "block.minecraft.banner.half_vertical.brown": "Partit, 1èr brun",
  "block.minecraft.banner.half_vertical.cyan": "Partit, 1èr cian",
  "block.minecraft.banner.half_vertical.gray": "Partit, 1èr gris",
  "block.minecraft.banner.half_vertical.green": "Partit, 1èr verd",
  "block.minecraft.banner.half_vertical.light_blue": "Partit, 1èr blau clar",
  "block.minecraft.banner.half_vertical.light_gray": "Partit, 1èr gris clar",
  "block.minecraft.banner.half_vertical.lime": "Partit, 1èr lima",
  "block.minecraft.banner.half_vertical.magenta": "Partit, 1èr magenta",
  "block.minecraft.banner.half_vertical.orange": "Partit, 1èr irange",
  "block.minecraft.banner.half_vertical.pink": "Partit, 1èr ròse",
  "block.minecraft.banner.half_vertical.purple": "Partit, 1èr violet",
  "block.minecraft.banner.half_vertical.red": "Partit, 1èr roge",
  "block.minecraft.banner.half_vertical.white": "Partit, 1èr blanc",
  "block.minecraft.banner.half_vertical.yellow": "Partit, 1èr jaune",
  "block.minecraft.banner.half_vertical_right.black": "Partit, 2nd negre",
  "block.minecraft.banner.half_vertical_right.blue": "Partit, 2nd blau",
  "block.minecraft.banner.half_vertical_right.brown": "Partit, 2nd brun",
  "block.minecraft.banner.half_vertical_right.cyan": "Partit, 2nd cian",
  "block.minecraft.banner.half_vertical_right.gray": "Partit, 2nd gris",
  "block.minecraft.banner.half_vertical_right.green": "Partit, 2nd verd",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partit, 2nd blau clar",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partit, 2nd blau clar",
  "block.minecraft.banner.half_vertical_right.lime": "Partit, 2nd lima",
  "block.minecraft.banner.half_vertical_right.magenta": "Partit, 2nd magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Partit, 2nd irange",
  "block.minecraft.banner.half_vertical_right.pink": "Partit, 2nd ròse",
  "block.minecraft.banner.half_vertical_right.purple": "Partit, 2nd violet",
  "block.minecraft.banner.half_vertical_right.red": "Partit, 2nd roge",
  "block.minecraft.banner.half_vertical_right.white": "Partit, 2nd blanc",
  "block.minecraft.banner.half_vertical_right.yellow": "Partit, 2nd jaune",
  "block.minecraft.banner.mojang.black": "Emblèma negra",
  "block.minecraft.banner.mojang.blue": "Emblèma blava",
  "block.minecraft.banner.mojang.brown": "Emblèma bruna",
  "block.minecraft.banner.mojang.cyan": "Emblèma cian",
  "block.minecraft.banner.mojang.gray": "Emblèma grisa",
  "block.minecraft.banner.mojang.green": "Emblèma verda",
  "block.minecraft.banner.mojang.light_blue": "Emblèma blau clar",
  "block.minecraft.banner.mojang.light_gray": "Emblèma gris clar",
  "block.minecraft.banner.mojang.lime": "Emblèma lima",
  "block.minecraft.banner.mojang.magenta": "Emblèma magenta",
  "block.minecraft.banner.mojang.orange": "Emblèma iranja",
  "block.minecraft.banner.mojang.pink": "Emblèma ròsa",
  "block.minecraft.banner.mojang.purple": "Emblèma violeta",
  "block.minecraft.banner.mojang.red": "Emblèma roja",
  "block.minecraft.banner.mojang.white": "Emblèma blanca",
  "block.minecraft.banner.mojang.yellow": "Emblèma jauna",
  "block.minecraft.banner.piglin.black": "Morre negre",
  "block.minecraft.banner.piglin.blue": "Morre blau",
  "block.minecraft.banner.piglin.brown": "Morre brun",
  "block.minecraft.banner.piglin.cyan": "Morre cian",
  "block.minecraft.banner.piglin.gray": "Morre gris",
  "block.minecraft.banner.piglin.green": "Morre verd",
  "block.minecraft.banner.piglin.light_blue": "Morre blau clar",
  "block.minecraft.banner.piglin.light_gray": "Morre gris clar",
  "block.minecraft.banner.piglin.lime": "Morre lima",
  "block.minecraft.banner.piglin.magenta": "Morre magenta",
  "block.minecraft.banner.piglin.orange": "Morre irange",
  "block.minecraft.banner.piglin.pink": "Morre ròse",
  "block.minecraft.banner.piglin.purple": "Morre violet",
  "block.minecraft.banner.piglin.red": "Morre roge",
  "block.minecraft.banner.piglin.white": "Morre blanc",
  "block.minecraft.banner.piglin.yellow": "Morre jaune",
  "block.minecraft.banner.rhombus.black": "Lausange negre",
  "block.minecraft.banner.rhombus.blue": "Lausange blau",
  "block.minecraft.banner.rhombus.brown": "Lausange brun",
  "block.minecraft.banner.rhombus.cyan": "Lausange cian",
  "block.minecraft.banner.rhombus.gray": "Lausange gris",
  "block.minecraft.banner.rhombus.green": "Lausange verd",
  "block.minecraft.banner.rhombus.light_blue": "Lausange blau clar",
  "block.minecraft.banner.rhombus.light_gray": "Lausange gris clar",
  "block.minecraft.banner.rhombus.lime": "Lausange lima",
  "block.minecraft.banner.rhombus.magenta": "Lausange magenta",
  "block.minecraft.banner.rhombus.orange": "Lausange irange",
  "block.minecraft.banner.rhombus.pink": "Lausange ròse",
  "block.minecraft.banner.rhombus.purple": "Lausange violet",
  "block.minecraft.banner.rhombus.red": "Lausange roge",
  "block.minecraft.banner.rhombus.white": "Lausange blanc",
  "block.minecraft.banner.rhombus.yellow": "Lausange jaune",
  "block.minecraft.banner.skull.black": "Crani negre",
  "block.minecraft.banner.skull.blue": "Crani blau",
  "block.minecraft.banner.skull.brown": "Crani brun",
  "block.minecraft.banner.skull.cyan": "Crani cian",
  "block.minecraft.banner.skull.gray": "Crani gris",
  "block.minecraft.banner.skull.green": "Crani verd",
  "block.minecraft.banner.skull.light_blue": "Crani blau clar",
  "block.minecraft.banner.skull.light_gray": "Crani gris clar",
  "block.minecraft.banner.skull.lime": "Crani lima",
  "block.minecraft.banner.skull.magenta": "Crani magenta",
  "block.minecraft.banner.skull.orange": "Crani irange",
  "block.minecraft.banner.skull.pink": "Crani ròse",
  "block.minecraft.banner.skull.purple": "Crani violet",
  "block.minecraft.banner.skull.red": "Crani roge",
  "block.minecraft.banner.skull.white": "Crani blanc",
  "block.minecraft.banner.skull.yellow": "Crani jaune",
  "block.minecraft.banner.small_stripes.black": "Quatre paus negres",
  "block.minecraft.banner.small_stripes.blue": "Quatre paus blaus",
  "block.minecraft.banner.small_stripes.brown": "Quatre paus bruns",
  "block.minecraft.banner.small_stripes.cyan": "Quatre paus cian",
  "block.minecraft.banner.small_stripes.gray": "Quatre paus grises",
  "block.minecraft.banner.small_stripes.green": "Quatre paus verds",
  "block.minecraft.banner.small_stripes.light_blue": "Quatre paus blau clar",
  "block.minecraft.banner.small_stripes.light_gray": "Quatre paus gris clar",
  "block.minecraft.banner.small_stripes.lime": "Quatre paus lima",
  "block.minecraft.banner.small_stripes.magenta": "Quatre paus magenta",
  "block.minecraft.banner.small_stripes.orange": "Quatre paus iranges",
  "block.minecraft.banner.small_stripes.pink": "Quatre paus ròses",
  "block.minecraft.banner.small_stripes.purple": "Quatre paus violets",
  "block.minecraft.banner.small_stripes.red": "Quatre paus roges",
  "block.minecraft.banner.small_stripes.white": "Quatre paus blancs",
  "block.minecraft.banner.small_stripes.yellow": "Quatre paus jaunes",
  "block.minecraft.banner.square_bottom_left.black": "Canton dèstre en poncha negre",
  "block.minecraft.banner.square_bottom_left.blue": "Canton dèstre en poncha blau",
  "block.minecraft.banner.square_bottom_left.brown": "Canton brun en basa a drecha",
  "block.minecraft.banner.square_bottom_left.cyan": "Canton dèstre en poncha cian",
  "block.minecraft.banner.square_bottom_left.gray": "Canton dèstre en poncha gris",
  "block.minecraft.banner.square_bottom_left.green": "Canton dèstre en poncha verd",
  "block.minecraft.banner.square_bottom_left.light_blue": "Canton dèstre en poncha blau clar",
  "block.minecraft.banner.square_bottom_left.light_gray": "Canton dèstre en poncha gris clar",
  "block.minecraft.banner.square_bottom_left.lime": "Canton dèstre en poncha lima",
  "block.minecraft.banner.square_bottom_left.magenta": "Canton dèstre en poncha magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Canton dèstre en poncha irange",
  "block.minecraft.banner.square_bottom_left.pink": "Canton dèstre en poncha ròse",
  "block.minecraft.banner.square_bottom_left.purple": "Canton dèstre en poncha violet",
  "block.minecraft.banner.square_bottom_left.red": "Canton dèstre en poncha roge",
  "block.minecraft.banner.square_bottom_left.white": "Canton dèstre en poncha blanc",
  "block.minecraft.banner.square_bottom_left.yellow": "Canton dèstre en poncha jaune",
  "block.minecraft.banner.square_bottom_right.black": "Canton senèstre en poncha negre",
  "block.minecraft.banner.square_bottom_right.blue": "Canton senèstre en poncha blau",
  "block.minecraft.banner.square_bottom_right.brown": "Canton senèstre en poncha brun",
  "block.minecraft.banner.square_bottom_right.cyan": "Canton senèstre en poncha cian",
  "block.minecraft.banner.square_bottom_right.gray": "Canton senèstre en poncha gris",
  "block.minecraft.banner.square_bottom_right.green": "Canton senèstre en poncha verd",
  "block.minecraft.banner.square_bottom_right.light_blue": "Canton senèstre en poncha blau clar",
  "block.minecraft.banner.square_bottom_right.light_gray": "Canton senèstre en poncha gris clar",
  "block.minecraft.banner.square_bottom_right.lime": "Canton senèstre en poncha lima",
  "block.minecraft.banner.square_bottom_right.magenta": "Canton senèstre en poncha magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Canton senèstre en poncha irange",
  "block.minecraft.banner.square_bottom_right.pink": "Canton senèstre en poncha ròse",
  "block.minecraft.banner.square_bottom_right.purple": "Canton senèstre en poncha violet",
  "block.minecraft.banner.square_bottom_right.red": "Canton senèstre en poncha roge",
  "block.minecraft.banner.square_bottom_right.white": "Canton senèstre en poncha blanc",
  "block.minecraft.banner.square_bottom_right.yellow": "Canton senèstre en poncha jaune",
  "block.minecraft.banner.square_top_left.black": "Canton dèstre en cap negre",
  "block.minecraft.banner.square_top_left.blue": "Canton dèstre en cap blau",
  "block.minecraft.banner.square_top_left.brown": "Canton dèstre en cap brun",
  "block.minecraft.banner.square_top_left.cyan": "Canton dèstre en cap cian",
  "block.minecraft.banner.square_top_left.gray": "Canton dèstre en cap gris",
  "block.minecraft.banner.square_top_left.green": "Canton dèstre en cap verd",
  "block.minecraft.banner.square_top_left.light_blue": "Canton dèstre en cap blau clar",
  "block.minecraft.banner.square_top_left.light_gray": "Canton dèstre en cap gris clar",
  "block.minecraft.banner.square_top_left.lime": "Canton dèstre en cap lima",
  "block.minecraft.banner.square_top_left.magenta": "Canton dèstre en cap magenta",
  "block.minecraft.banner.square_top_left.orange": "Canton dèstre en cap irange",
  "block.minecraft.banner.square_top_left.pink": "Canton dèstre en cap ròse",
  "block.minecraft.banner.square_top_left.purple": "Canton dèstre en cap violet",
  "block.minecraft.banner.square_top_left.red": "Canton dèstre en cap roge",
  "block.minecraft.banner.square_top_left.white": "Canton dèstre en cap blanc",
  "block.minecraft.banner.square_top_left.yellow": "Canton dèstre en cap jaune",
  "block.minecraft.banner.square_top_right.black": "Canton senèstre en cap blanc",
  "block.minecraft.banner.square_top_right.blue": "Canton senèstre en cap blau",
  "block.minecraft.banner.square_top_right.brown": "Canton senèstre en cap brun",
  "block.minecraft.banner.square_top_right.cyan": "Canton senèstre en cap cian",
  "block.minecraft.banner.square_top_right.gray": "Canton senèstre en cap gris",
  "block.minecraft.banner.square_top_right.green": "Canton senèstre en cap verd",
  "block.minecraft.banner.square_top_right.light_blue": "Canton senèstre en cap blau clar",
  "block.minecraft.banner.square_top_right.light_gray": "Canton senèstre en cap gris clar",
  "block.minecraft.banner.square_top_right.lime": "Canton senèstre en cap lima",
  "block.minecraft.banner.square_top_right.magenta": "Canton senèstre en cap magenta",
  "block.minecraft.banner.square_top_right.orange": "Canton senèstre en cap irange",
  "block.minecraft.banner.square_top_right.pink": "Canton senèstre en cap ròse",
  "block.minecraft.banner.square_top_right.purple": "Canton senèstre en cap violet",
  "block.minecraft.banner.square_top_right.red": "Canton senèstre en cap roge",
  "block.minecraft.banner.square_top_right.white": "Canton senèstre en cap blanc",
  "block.minecraft.banner.square_top_right.yellow": "Canton senèstre en cap jaune",
  "block.minecraft.banner.straight_cross.black": "Crotz negra",
  "block.minecraft.banner.straight_cross.blue": "Crotz blava",
  "block.minecraft.banner.straight_cross.brown": "Crotz bruna",
  "block.minecraft.banner.straight_cross.cyan": "Crotz cian",
  "block.minecraft.banner.straight_cross.gray": "Crotz grisa",
  "block.minecraft.banner.straight_cross.green": "Crotz verda",
  "block.minecraft.banner.straight_cross.light_blue": "Crotz blau clar",
  "block.minecraft.banner.straight_cross.light_gray": "Crotz gris clar",
  "block.minecraft.banner.straight_cross.lime": "Crotz lima",
  "block.minecraft.banner.straight_cross.magenta": "Crotz magenta",
  "block.minecraft.banner.straight_cross.orange": "Crotz iranja",
  "block.minecraft.banner.straight_cross.pink": "Crotz ròsa",
  "block.minecraft.banner.straight_cross.purple": "Crotz violeta",
  "block.minecraft.banner.straight_cross.red": "Crotz roja",
  "block.minecraft.banner.straight_cross.white": "Crotz blanca",
  "block.minecraft.banner.straight_cross.yellow": "Crotz jauna",
  "block.minecraft.banner.stripe_bottom.black": "Campanha negra",
  "block.minecraft.banner.stripe_bottom.blue": "Campanha blava",
  "block.minecraft.banner.stripe_bottom.brown": "Campanha bruna",
  "block.minecraft.banner.stripe_bottom.cyan": "Campanha cian",
  "block.minecraft.banner.stripe_bottom.gray": "Campanha grisa",
  "block.minecraft.banner.stripe_bottom.green": "Campanha verda",
  "block.minecraft.banner.stripe_bottom.light_blue": "Campanha blau clar",
  "block.minecraft.banner.stripe_bottom.light_gray": "Campanha gris clar",
  "block.minecraft.banner.stripe_bottom.lime": "Campanha lima",
  "block.minecraft.banner.stripe_bottom.magenta": "Campanha magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Campanha iranja",
  "block.minecraft.banner.stripe_bottom.pink": "Campanha ròsa",
  "block.minecraft.banner.stripe_bottom.purple": "Campanha violeta",
  "block.minecraft.banner.stripe_bottom.red": "Campanha roja",
  "block.minecraft.banner.stripe_bottom.white": "Campanha blanca",
  "block.minecraft.banner.stripe_bottom.yellow": "Campanha jauna",
  "block.minecraft.banner.stripe_center.black": "Pau negre",
  "block.minecraft.banner.stripe_center.blue": "Pau blau",
  "block.minecraft.banner.stripe_center.brown": "Pau brun",
  "block.minecraft.banner.stripe_center.cyan": "Pau cian",
  "block.minecraft.banner.stripe_center.gray": "Pau gris",
  "block.minecraft.banner.stripe_center.green": "Pau verd",
  "block.minecraft.banner.stripe_center.light_blue": "Pau blau clar",
  "block.minecraft.banner.stripe_center.light_gray": "Pau gris clar",
  "block.minecraft.banner.stripe_center.lime": "Pau lima",
  "block.minecraft.banner.stripe_center.magenta": "Pau magenta",
  "block.minecraft.banner.stripe_center.orange": "Pau irange",
  "block.minecraft.banner.stripe_center.pink": "Pau ròse",
  "block.minecraft.banner.stripe_center.purple": "Pau violet",
  "block.minecraft.banner.stripe_center.red": "Pau roge",
  "block.minecraft.banner.stripe_center.white": "Pau blanc",
  "block.minecraft.banner.stripe_center.yellow": "Pau jaune",
  "block.minecraft.banner.stripe_downleft.black": "Barra negra",
  "block.minecraft.banner.stripe_downleft.blue": "Barra blava",
  "block.minecraft.banner.stripe_downleft.brown": "Barra bruna",
  "block.minecraft.banner.stripe_downleft.cyan": "Barra cian",
  "block.minecraft.banner.stripe_downleft.gray": "Barra grisa",
  "block.minecraft.banner.stripe_downleft.green": "Barra verda",
  "block.minecraft.banner.stripe_downleft.light_blue": "Barra blau clar",
  "block.minecraft.banner.stripe_downleft.light_gray": "Barra gris clar",
  "block.minecraft.banner.stripe_downleft.lime": "Barra lima",
  "block.minecraft.banner.stripe_downleft.magenta": "Barra magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Barra iranja",
  "block.minecraft.banner.stripe_downleft.pink": "Barra ròsa",
  "block.minecraft.banner.stripe_downleft.purple": "Barra violeta",
  "block.minecraft.banner.stripe_downleft.red": "Barra roja",
  "block.minecraft.banner.stripe_downleft.white": "Barra blanca",
  "block.minecraft.banner.stripe_downleft.yellow": "Barra jauna",
  "block.minecraft.banner.stripe_downright.black": "Benda negra",
  "block.minecraft.banner.stripe_downright.blue": "Benda blava",
  "block.minecraft.banner.stripe_downright.brown": "Benda bruna",
  "block.minecraft.banner.stripe_downright.cyan": "Benda cian",
  "block.minecraft.banner.stripe_downright.gray": "Benda grisa",
  "block.minecraft.banner.stripe_downright.green": "Benda verda",
  "block.minecraft.banner.stripe_downright.light_blue": "Benda blau clar",
  "block.minecraft.banner.stripe_downright.light_gray": "Benda gris clar",
  "block.minecraft.banner.stripe_downright.lime": "Benda lima",
  "block.minecraft.banner.stripe_downright.magenta": "Benda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Benda iranja",
  "block.minecraft.banner.stripe_downright.pink": "Benda ròsa",
  "block.minecraft.banner.stripe_downright.purple": "Benda violeta",
  "block.minecraft.banner.stripe_downright.red": "Benda roja",
  "block.minecraft.banner.stripe_downright.white": "Benda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Benda jauna",
  "block.minecraft.banner.stripe_left.black": "Pau dèstre negre",
  "block.minecraft.banner.stripe_left.blue": "Pau dèstre blau",
  "block.minecraft.banner.stripe_left.brown": "Pau dèstre brun",
  "block.minecraft.banner.stripe_left.cyan": "Pau dèstre cian",
  "block.minecraft.banner.stripe_left.gray": "Pau dèstre gris",
  "block.minecraft.banner.stripe_left.green": "Pau dèstre verd",
  "block.minecraft.banner.stripe_left.light_blue": "Pau dèstre blau clar",
  "block.minecraft.banner.stripe_left.light_gray": "Pau dèstre gris clar",
  "block.minecraft.banner.stripe_left.lime": "Pau dèstre lima",
  "block.minecraft.banner.stripe_left.magenta": "Pau dèstre magenta",
  "block.minecraft.banner.stripe_left.orange": "Pau dèstre irange",
  "block.minecraft.banner.stripe_left.pink": "Pau dèstre ròse",
  "block.minecraft.banner.stripe_left.purple": "Pau dèstre violet",
  "block.minecraft.banner.stripe_left.red": "Pau dèstre roge",
  "block.minecraft.banner.stripe_left.white": "Pau dèstre blanc",
  "block.minecraft.banner.stripe_left.yellow": "Pau dèstre jaune",
  "block.minecraft.banner.stripe_middle.black": "Faissa negra",
  "block.minecraft.banner.stripe_middle.blue": "Faissa blava",
  "block.minecraft.banner.stripe_middle.brown": "Faissa bruna",
  "block.minecraft.banner.stripe_middle.cyan": "Faissa cian",
  "block.minecraft.banner.stripe_middle.gray": "Faissa grisa",
  "block.minecraft.banner.stripe_middle.green": "Faissa verda",
  "block.minecraft.banner.stripe_middle.light_blue": "Faissa blau clar",
  "block.minecraft.banner.stripe_middle.light_gray": "Faissa gris clar",
  "block.minecraft.banner.stripe_middle.lime": "Faissa lima",
  "block.minecraft.banner.stripe_middle.magenta": "Faissa magenta",
  "block.minecraft.banner.stripe_middle.orange": "Faissa iranja",
  "block.minecraft.banner.stripe_middle.pink": "Faissa ròsa",
  "block.minecraft.banner.stripe_middle.purple": "Faissa violeta",
  "block.minecraft.banner.stripe_middle.red": "Faissa roja",
  "block.minecraft.banner.stripe_middle.white": "Faissa blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Faissa jauna",
  "block.minecraft.banner.stripe_right.black": "Pau senèstre negre",
  "block.minecraft.banner.stripe_right.blue": "Pau dèstre blau",
  "block.minecraft.banner.stripe_right.brown": "Pau senèstre brun",
  "block.minecraft.banner.stripe_right.cyan": "Pau senèstre cian",
  "block.minecraft.banner.stripe_right.gray": "Pau senèstre gris",
  "block.minecraft.banner.stripe_right.green": "Pau senèstre verd",
  "block.minecraft.banner.stripe_right.light_blue": "Pau senèstre blau clar",
  "block.minecraft.banner.stripe_right.light_gray": "Pau senèstre gris clar",
  "block.minecraft.banner.stripe_right.lime": "Pau senèstre lima",
  "block.minecraft.banner.stripe_right.magenta": "Pau senèstre magenta",
  "block.minecraft.banner.stripe_right.orange": "Pau senèstre irange",
  "block.minecraft.banner.stripe_right.pink": "Pau senèstre ròse",
  "block.minecraft.banner.stripe_right.purple": "Pau senèstre violet",
  "block.minecraft.banner.stripe_right.red": "Pau senèstre roge",
  "block.minecraft.banner.stripe_right.white": "Pau senèstre blanc",
  "block.minecraft.banner.stripe_right.yellow": "Pau senèstre jaune",
  "block.minecraft.banner.stripe_top.black": "Cap negre",
  "block.minecraft.banner.stripe_top.blue": "Cap blau",
  "block.minecraft.banner.stripe_top.brown": "Cap brun",
  "block.minecraft.banner.stripe_top.cyan": "Cap cian",
  "block.minecraft.banner.stripe_top.gray": "Cap gris",
  "block.minecraft.banner.stripe_top.green": "Cap verd",
  "block.minecraft.banner.stripe_top.light_blue": "Cap blau clar",
  "block.minecraft.banner.stripe_top.light_gray": "Cap gris clar",
  "block.minecraft.banner.stripe_top.lime": "Cap lima",
  "block.minecraft.banner.stripe_top.magenta": "Cap magenta",
  "block.minecraft.banner.stripe_top.orange": "Cap irange",
  "block.minecraft.banner.stripe_top.pink": "Cap ròse",
  "block.minecraft.banner.stripe_top.purple": "Cap violet",
  "block.minecraft.banner.stripe_top.red": "Cap roge",
  "block.minecraft.banner.stripe_top.white": "Cap blanc",
  "block.minecraft.banner.stripe_top.yellow": "Cap jaune",
  "block.minecraft.banner.triangle_bottom.black": "Mantelat negre",
  "block.minecraft.banner.triangle_bottom.blue": "Mantelat blau",
  "block.minecraft.banner.triangle_bottom.brown": "Mantelat brun",
  "block.minecraft.banner.triangle_bottom.cyan": "Mantelat cian",
  "block.minecraft.banner.triangle_bottom.gray": "Mantelat gris",
  "block.minecraft.banner.triangle_bottom.green": "Mantelat verd",
  "block.minecraft.banner.triangle_bottom.light_blue": "Mantelat gris clar",
  "block.minecraft.banner.triangle_bottom.light_gray": "Mantelat gris clar",
  "block.minecraft.banner.triangle_bottom.lime": "Mantelat lima",
  "block.minecraft.banner.triangle_bottom.magenta": "Mantelat magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Mantelat irange",
  "block.minecraft.banner.triangle_bottom.pink": "Mantelat ròse",
  "block.minecraft.banner.triangle_bottom.purple": "Mantelat violet",
  "block.minecraft.banner.triangle_bottom.red": "Mantelat roge",
  "block.minecraft.banner.triangle_bottom.white": "Mantelat blanc",
  "block.minecraft.banner.triangle_bottom.yellow": "Mantelat jaune",
  "block.minecraft.banner.triangle_top.black": "Mantelat reversat negre",
  "block.minecraft.banner.triangle_top.blue": "Mantelat reversat blau",
  "block.minecraft.banner.triangle_top.brown": "Mantelat reversat brun",
  "block.minecraft.banner.triangle_top.cyan": "Mantelat reversat cian",
  "block.minecraft.banner.triangle_top.gray": "Mantelat reversat gris",
  "block.minecraft.banner.triangle_top.green": "Mantelat reversat verd",
  "block.minecraft.banner.triangle_top.light_blue": "Mantelat reversat blau clar",
  "block.minecraft.banner.triangle_top.light_gray": "Mantelat reversat gris clar",
  "block.minecraft.banner.triangle_top.lime": "Mantelat reversat lima",
  "block.minecraft.banner.triangle_top.magenta": "Mantelat reversat magenta",
  "block.minecraft.banner.triangle_top.orange": "Mantelat reversat irange",
  "block.minecraft.banner.triangle_top.pink": "Mantelat reversat ròse",
  "block.minecraft.banner.triangle_top.purple": "Mantelat reversat violet",
  "block.minecraft.banner.triangle_top.red": "Mantelat reversat roge",
  "block.minecraft.banner.triangle_top.white": "Mantelat reversat blanc",
  "block.minecraft.banner.triangle_top.yellow": "Mantelat reversat jaune",
  "block.minecraft.banner.triangles_bottom.black": "Encaissadura negra en poncha",
  "block.minecraft.banner.triangles_bottom.blue": "Encaissadura blava en poncha",
  "block.minecraft.banner.triangles_bottom.brown": "Encaissadura bruna en poncha",
  "block.minecraft.banner.triangles_bottom.cyan": "Encaissadura cian en poncha",
  "block.minecraft.banner.triangles_bottom.gray": "Encaissadura grisa en poncha",
  "block.minecraft.banner.triangles_bottom.green": "Encaissadura verda en poncha",
  "block.minecraft.banner.triangles_bottom.light_blue": "Encaissadura blau clar en poncha",
  "block.minecraft.banner.triangles_bottom.light_gray": "Encaissadura gris clar en poncha",
  "block.minecraft.banner.triangles_bottom.lime": "Encaissadura lima en poncha",
  "block.minecraft.banner.triangles_bottom.magenta": "Encaissadura magenta en poncha",
  "block.minecraft.banner.triangles_bottom.orange": "Encaissadura iranja en poncha",
  "block.minecraft.banner.triangles_bottom.pink": "Encaissadura ròsa en poncha",
  "block.minecraft.banner.triangles_bottom.purple": "Encaissadura violeta en poncha",
  "block.minecraft.banner.triangles_bottom.red": "Encaissadura roja en poncha",
  "block.minecraft.banner.triangles_bottom.white": "Encaissadura blanca en poncha",
  "block.minecraft.banner.triangles_bottom.yellow": "Encaissadura jauna en poncha",
  "block.minecraft.banner.triangles_top.black": "Encaissadura negra en cap",
  "block.minecraft.banner.triangles_top.blue": "Encaissadura blava en cap",
  "block.minecraft.banner.triangles_top.brown": "Encaissadura bruna en cap",
  "block.minecraft.banner.triangles_top.cyan": "Encaissadura cian en cap",
  "block.minecraft.banner.triangles_top.gray": "Encaissadura grisa en cap",
  "block.minecraft.banner.triangles_top.green": "Encaissadura verda en cap",
  "block.minecraft.banner.triangles_top.light_blue": "Encaissadura blau clar en cap",
  "block.minecraft.banner.triangles_top.light_gray": "Encaissadura gris clar en cap",
  "block.minecraft.banner.triangles_top.lime": "Encaissadura lima en cap",
  "block.minecraft.banner.triangles_top.magenta": "Encaissadura magenta en cap",
  "block.minecraft.banner.triangles_top.orange": "Encaissadura iranja en cap",
  "block.minecraft.banner.triangles_top.pink": "Encaissadura ròsa en cap",
  "block.minecraft.banner.triangles_top.purple": "Encaissadura violeta en cap",
  "block.minecraft.banner.triangles_top.red": "Encaissadura roja en cap",
  "block.minecraft.banner.triangles_top.white": "Encaissadura blanca en cap",
  "block.minecraft.banner.triangles_top.yellow": "Encaissadura jauna en cap",
  "block.minecraft.barrel": "Barrica",
  "block.minecraft.barrier": "Barralha invisibla",
  "block.minecraft.basalt": "Basalte",
  "block.minecraft.beacon": "Balisa",
  "block.minecraft.beacon.primary": "Poder Primièr",
  "block.minecraft.beacon.secondary": "Poder Segond",
  "block.minecraft.bed.no_sleep": "Podètz dormir sonque la nuèch o pendent los auratges",
  "block.minecraft.bed.not_safe": "Podètz pas dormir ara; i a de monstres a proximitat",
  "block.minecraft.bed.obstructed": "Aquest lièch es obstruït",
  "block.minecraft.bed.occupied": "Aqueste lièch es ocupat",
  "block.minecraft.bed.too_far_away": "Podètz pas dormir ara; lo lièch es tròp luènh",
  "block.minecraft.bedrock": "Ròca de basa",
  "block.minecraft.bee_nest": "Nis d'abelhas",
  "block.minecraft.beehive": "Bornhon artificiau",
  "block.minecraft.beetroots": "Bledaravas",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Gotafuèlha granda",
  "block.minecraft.big_dripleaf_stem": "Tija de gotafuèlha granda",
  "block.minecraft.birch_button": "Boton en bèç",
  "block.minecraft.birch_door": "Pòrta en bèç",
  "block.minecraft.birch_fence": "Barralha en bèç",
  "block.minecraft.birch_fence_gate": "Pòrta de barralha en bèç",
  "block.minecraft.birch_hanging_sign": "Pancarta penjanta en bèç",
  "block.minecraft.birch_leaves": "Fuèlhas de bèç",
  "block.minecraft.birch_log": "Busca de bèç",
  "block.minecraft.birch_planks": "Plancas de bèç",
  "block.minecraft.birch_pressure_plate": "Placa de pression en bèç",
  "block.minecraft.birch_sapling": "Grelh de bèç",
  "block.minecraft.birch_shelf": "Estaudèla en bèç",
  "block.minecraft.birch_sign": "Pancarta en bèç",
  "block.minecraft.birch_slab": "Lausa en bèç",
  "block.minecraft.birch_stairs": "Escalièrs en bèç",
  "block.minecraft.birch_trapdoor": "Trapa en bèç",
  "block.minecraft.birch_wall_hanging_sign": "Pancarta penjanta en bèç murala",
  "block.minecraft.birch_wall_sign": "Pancarta en bèç murala",
  "block.minecraft.birch_wood": "Fusta de bèç",
  "block.minecraft.black_banner": "Bandièra negra",
  "block.minecraft.black_bed": "Lièch negre",
  "block.minecraft.black_candle": "Candèla negra",
  "block.minecraft.black_candle_cake": "Pastís amb candèla negra",
  "block.minecraft.black_carpet": "Moqueta negra",
  "block.minecraft.black_concrete": "Beton negre",
  "block.minecraft.black_concrete_powder": "Polsa de beton negra",
  "block.minecraft.black_glazed_terracotta": "Tèrra cuècha esmautada negra",
  "block.minecraft.black_shulker_box": "Bóstia de Shulker negra",
  "block.minecraft.black_stained_glass": "Veire negre",
  "block.minecraft.black_stained_glass_pane": "Panèu de veire negre",
  "block.minecraft.black_terracotta": "Tèrra cuècha negra",
  "block.minecraft.black_wool": "Lana negra",
  "block.minecraft.blackstone": "Ròca negra",
  "block.minecraft.blackstone_slab": "Lausa de ròca negra",
  "block.minecraft.blackstone_stairs": "Escalièrs de ròca negra",
  "block.minecraft.blackstone_wall": "Muret de ròca negra",
  "block.minecraft.blast_furnace": "Fornèl de fusion",
  "block.minecraft.blue_banner": "Bandièra blava",
  "block.minecraft.blue_bed": "Lièch blau",
  "block.minecraft.blue_candle": "Candèla blava",
  "block.minecraft.blue_candle_cake": "Pastís amb candèla blava",
  "block.minecraft.blue_carpet": "Moqueta blava",
  "block.minecraft.blue_concrete": "Beton blau",
  "block.minecraft.blue_concrete_powder": "Polsa de beton blava",
  "block.minecraft.blue_glazed_terracotta": "Tèrra cuècha esmautada blava",
  "block.minecraft.blue_ice": "Glaç blau",
  "block.minecraft.blue_orchid": "Orquidèa blava",
  "block.minecraft.blue_shulker_box": "Bóstia de Shulker blava",
  "block.minecraft.blue_stained_glass": "Veire blau",
  "block.minecraft.blue_stained_glass_pane": "Panèu de veire blau",
  "block.minecraft.blue_terracotta": "Tèrra cuècha blava",
  "block.minecraft.blue_wool": "Lana blava",
  "block.minecraft.bone_block": "Blòc d'òsses",
  "block.minecraft.bookshelf": "Bibliotèca",
  "block.minecraft.brain_coral": "Coralh de cervèu",
  "block.minecraft.brain_coral_block": "Blòc de coralh de cervèu",
  "block.minecraft.brain_coral_fan": "Gorgònia de coralh de cervèu",
  "block.minecraft.brain_coral_wall_fan": "Gorgònia de coralh de cervèu murala",
  "block.minecraft.brewing_stand": "Alambic",
  "block.minecraft.brick_slab": "Lausa en bricas",
  "block.minecraft.brick_stairs": "Escalièrs en bricas",
  "block.minecraft.brick_wall": "Muret de bricas",
  "block.minecraft.bricks": "Bricas",
  "block.minecraft.brown_banner": "Bandièra bruna",
  "block.minecraft.brown_bed": "Lièch brun",
  "block.minecraft.brown_candle": "Candèla bruna",
  "block.minecraft.brown_candle_cake": "Pastís amb candèla bruna",
  "block.minecraft.brown_carpet": "Moqueta bruna",
  "block.minecraft.brown_concrete": "Beton brun",
  "block.minecraft.brown_concrete_powder": "Polsa de beton bruna",
  "block.minecraft.brown_glazed_terracotta": "Tèrra cuècha esmautada bruna",
  "block.minecraft.brown_mushroom": "Camparòu brun",
  "block.minecraft.brown_mushroom_block": "Blòc de camparòu brun",
  "block.minecraft.brown_shulker_box": "Bóstia de Shulker bruna",
  "block.minecraft.brown_stained_glass": "Veire brun",
  "block.minecraft.brown_stained_glass_pane": "Panèu de veire brun",
  "block.minecraft.brown_terracotta": "Tèrra cuècha bruna",
  "block.minecraft.brown_wool": "Lana bruna",
  "block.minecraft.bubble_column": "Colomna de botiòlas",
  "block.minecraft.bubble_coral": "Coralh de botiòla",
  "block.minecraft.bubble_coral_block": "Blòc de coralh de botiòla",
  "block.minecraft.bubble_coral_fan": "Gorgònia de coralh de botiòla",
  "block.minecraft.bubble_coral_wall_fan": "Gorgònia de coralh de botiòla murala",
  "block.minecraft.budding_amethyst": "Drusa d'ametista",
  "block.minecraft.bush": "Boisson",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de cactus",
  "block.minecraft.cake": "Pastís",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Captaire Sculk calibrat",
  "block.minecraft.campfire": "Fuòc de camp",
  "block.minecraft.candle": "Candèla",
  "block.minecraft.candle_cake": "Pastís amb candèla",
  "block.minecraft.carrots": "Pastenagas",
  "block.minecraft.cartography_table": "Taula de cartografia",
  "block.minecraft.carved_pumpkin": "Coja escultada",
  "block.minecraft.cauldron": "Pairòla",
  "block.minecraft.cave_air": "Aire de bauma",
  "block.minecraft.cave_vines": "Lianas de bauma",
  "block.minecraft.cave_vines_plant": "Planta de lianas de bauma",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Blòc de comandas en cadena",
  "block.minecraft.cherry_button": "Boton en cerièis",
  "block.minecraft.cherry_door": "Pòrta en cerièis",
  "block.minecraft.cherry_fence": "Barralha en cerièis",
  "block.minecraft.cherry_fence_gate": "Pòrta de barralha en cerièis",
  "block.minecraft.cherry_hanging_sign": "Pancarta penjanta en cerièis",
  "block.minecraft.cherry_leaves": "Fuèlhas de cerièis",
  "block.minecraft.cherry_log": "Busca de cerièis",
  "block.minecraft.cherry_planks": "Plancas en cerièis",
  "block.minecraft.cherry_pressure_plate": "Placa de pression en cerièis",
  "block.minecraft.cherry_sapling": "Grelh de cerièis",
  "block.minecraft.cherry_shelf": "Estaudèla en cerièis",
  "block.minecraft.cherry_sign": "Pancarta en cerièis",
  "block.minecraft.cherry_slab": "Lausa en cerièis",
  "block.minecraft.cherry_stairs": "Escalièrs en cerièis",
  "block.minecraft.cherry_trapdoor": "Trapa en cerièis",
  "block.minecraft.cherry_wall_hanging_sign": "Pancarta penjanta en cerièis murala",
  "block.minecraft.cherry_wall_sign": "Pancarta en cerièis murala",
  "block.minecraft.cherry_wood": "Fusta en cerièis",
  "block.minecraft.chest": "Còfre",
  "block.minecraft.chipped_anvil": "Enclutge bercat",
  "block.minecraft.chiseled_bookshelf": "Bibliotèca escultada",
  "block.minecraft.chiseled_copper": "Coire escultat",
  "block.minecraft.chiseled_deepslate": "Ardesa prigonda escultada",
  "block.minecraft.chiseled_nether_bricks": "Bricas dau Nether escultadas",
  "block.minecraft.chiseled_polished_blackstone": "Ròca negra escultada",
  "block.minecraft.chiseled_quartz_block": "Blòc de qüars escultat",
  "block.minecraft.chiseled_red_sandstone": "Gres roge escultat",
  "block.minecraft.chiseled_resin_bricks": "Bricas de resina escultadas",
  "block.minecraft.chiseled_sandstone": "Gres escultat",
  "block.minecraft.chiseled_stone_bricks": "Bricas de pèira escultadas",
  "block.minecraft.chiseled_tuff": "Tuf escultat",
  "block.minecraft.chiseled_tuff_bricks": "Bricas de Tuf Escalpradas",
  "block.minecraft.chorus_flower": "Flor de còrus",
  "block.minecraft.chorus_plant": "Planta de còrus",
  "block.minecraft.clay": "Argila",
  "block.minecraft.closed_eyeblossom": "Uèlhquidèa barrata",
  "block.minecraft.coal_block": "Blòc de carbon",
  "block.minecraft.coal_ore": "Minièra de carbon",
  "block.minecraft.coarse_dirt": "Tèrra estèrla",
  "block.minecraft.cobbled_deepslate": "Pèiras d'ardesa prigonda",
  "block.minecraft.cobbled_deepslate_slab": "Lausa en pèiras d'ardesa prigonda",
  "block.minecraft.cobbled_deepslate_stairs": "Escalièrs en pèiras d'ardesa prigonda",
  "block.minecraft.cobbled_deepslate_wall": "Muret en pèiras d'ardesa prigonda",
  "block.minecraft.cobblestone": "Pèiras",
  "block.minecraft.cobblestone_slab": "Lausa de pèiras",
  "block.minecraft.cobblestone_stairs": "Escalièrs de pèiras",
  "block.minecraft.cobblestone_wall": "Mur de pèiras",
  "block.minecraft.cobweb": "Telaranha",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Blòc de comandas",
  "block.minecraft.comparator": "Comparator de redstone",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Conduch",
  "block.minecraft.copper_bars": "Copper Bars",
  "block.minecraft.copper_block": "Blòc de coire",
  "block.minecraft.copper_bulb": "Ampola en coire",
  "block.minecraft.copper_chain": "Copper Chain",
  "block.minecraft.copper_chest": "Copper Chest",
  "block.minecraft.copper_door": "Pòrta en coire",
  "block.minecraft.copper_golem_statue": "Copper Golem Statue",
  "block.minecraft.copper_grate": "Grasilha en coire",
  "block.minecraft.copper_lantern": "Copper Lantern",
  "block.minecraft.copper_ore": "Minièra de coire",
  "block.minecraft.copper_torch": "Copper Torch",
  "block.minecraft.copper_trapdoor": "Trapa en coire",
  "block.minecraft.copper_wall_torch": "Copper Wall Torch",
  "block.minecraft.cornflower": "Blavet",
  "block.minecraft.cracked_deepslate_bricks": "Bricas d'ardesa prigonda fendilhadas",
  "block.minecraft.cracked_deepslate_tiles": "Rajòlas d'ardesa prigonda fendilhadas",
  "block.minecraft.cracked_nether_bricks": "Bricas dau Nether fendilhadas",
  "block.minecraft.cracked_polished_blackstone_bricks": "Bricas de ròca negra fendilhadas",
  "block.minecraft.cracked_stone_bricks": "Bricas de pèira fendilhadas",
  "block.minecraft.crafter": "Fabricator",
  "block.minecraft.crafting_table": "Taula de trabalh",
  "block.minecraft.creaking_heart": "Còr de cruisseire",
  "block.minecraft.creeper_head": "Cap de creeper",
  "block.minecraft.creeper_wall_head": "Cap de creeper murau",
  "block.minecraft.crimson_button": "Boton cremesin",
  "block.minecraft.crimson_door": "Pòrta cremesina",
  "block.minecraft.crimson_fence": "Barralha cremesina",
  "block.minecraft.crimson_fence_gate": "Pòrta de barralha cremesina",
  "block.minecraft.crimson_fungus": "Fonge cremesin",
  "block.minecraft.crimson_hanging_sign": "Pancarta penjanta cremesina",
  "block.minecraft.crimson_hyphae": "Ifas cremesinas",
  "block.minecraft.crimson_nylium": "Nicèli cremesin",
  "block.minecraft.crimson_planks": "Plancas cremesinas",
  "block.minecraft.crimson_pressure_plate": "Placa de pression cremesina",
  "block.minecraft.crimson_roots": "Raices cremesins",
  "block.minecraft.crimson_shelf": "Estaudèla cremesina",
  "block.minecraft.crimson_sign": "Pancarta cremesina",
  "block.minecraft.crimson_slab": "Lausa cremesina",
  "block.minecraft.crimson_stairs": "Escalièrs cremesins",
  "block.minecraft.crimson_stem": "Tija cremesina",
  "block.minecraft.crimson_trapdoor": "Trapa cremesina",
  "block.minecraft.crimson_wall_hanging_sign": "Pancarta penjanta cremesina murala",
  "block.minecraft.crimson_wall_sign": "Pancarta cremesina murala",
  "block.minecraft.crying_obsidian": "Obsidiana plorosa",
  "block.minecraft.cut_copper": "Coire talhat",
  "block.minecraft.cut_copper_slab": "Lausa en coire talhada",
  "block.minecraft.cut_copper_stairs": "Escalièrs en coire talhat",
  "block.minecraft.cut_red_sandstone": "Gres roge talhat",
  "block.minecraft.cut_red_sandstone_slab": "Lausa en gres roge talhat",
  "block.minecraft.cut_sandstone": "Gres talhat",
  "block.minecraft.cut_sandstone_slab": "Lausa en gres talhat",
  "block.minecraft.cyan_banner": "Bandièra cian",
  "block.minecraft.cyan_bed": "Lièch cian",
  "block.minecraft.cyan_candle": "Candèla cian",
  "block.minecraft.cyan_candle_cake": "Pastís amb candèla cian",
  "block.minecraft.cyan_carpet": "Moqueta cian",
  "block.minecraft.cyan_concrete": "Beton cian",
  "block.minecraft.cyan_concrete_powder": "Polsa de beton cian",
  "block.minecraft.cyan_glazed_terracotta": "Tèrra cuècha esmautada cian",
  "block.minecraft.cyan_shulker_box": "Bóstia de Shulker cian",
  "block.minecraft.cyan_stained_glass": "Veire cian",
  "block.minecraft.cyan_stained_glass_pane": "Panèu de veire cian",
  "block.minecraft.cyan_terracotta": "Tèrra cuècha cian",
  "block.minecraft.cyan_wool": "Lana cian",
  "block.minecraft.damaged_anvil": "Enclutge damatjat",
  "block.minecraft.dandelion": "Pissalach",
  "block.minecraft.dark_oak_button": "Boton en euse escur",
  "block.minecraft.dark_oak_door": "Pòrta en euse escur",
  "block.minecraft.dark_oak_fence": "Barralha en euse escur",
  "block.minecraft.dark_oak_fence_gate": "Pòrta de barralha en euse escur",
  "block.minecraft.dark_oak_hanging_sign": "Pancarta penjanta en euse escur",
  "block.minecraft.dark_oak_leaves": "Fuèlhas d'euse escur",
  "block.minecraft.dark_oak_log": "Busca d'euse escur",
  "block.minecraft.dark_oak_planks": "Plancas d'euse escur",
  "block.minecraft.dark_oak_pressure_plate": "Placa de pression en euse escur",
  "block.minecraft.dark_oak_sapling": "Grelh d'euse escur",
  "block.minecraft.dark_oak_shelf": "Estaudèla en euse escur",
  "block.minecraft.dark_oak_sign": "Pancarta en euse escur",
  "block.minecraft.dark_oak_slab": "Lausa en euse escur",
  "block.minecraft.dark_oak_stairs": "Escalièrs en euse escur",
  "block.minecraft.dark_oak_trapdoor": "Trapa en euse escur",
  "block.minecraft.dark_oak_wall_hanging_sign": "Pancarta penjanta en euse escur murala",
  "block.minecraft.dark_oak_wall_sign": "Pancarta en euse escur murala",
  "block.minecraft.dark_oak_wood": "Fusta d'euse escur",
  "block.minecraft.dark_prismarine": "Prismarina escura",
  "block.minecraft.dark_prismarine_slab": "Lausa de prismarina escura",
  "block.minecraft.dark_prismarine_stairs": "Escalièrs en prismarina escura",
  "block.minecraft.daylight_detector": "Detector de lutz solara",
  "block.minecraft.dead_brain_coral": "Coralh de cervèu mòrt",
  "block.minecraft.dead_brain_coral_block": "Blòc de coralh de cervèu mòrt",
  "block.minecraft.dead_brain_coral_fan": "Gorgònia de coralh de cervèu mòrt",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgònia de coralh de cervèu mòrt murala",
  "block.minecraft.dead_bubble_coral": "Coralh de botiòla mòrt",
  "block.minecraft.dead_bubble_coral_block": "Blòc de coralh de botiòla mòrt",
  "block.minecraft.dead_bubble_coral_fan": "Gorgònia de coralh de botiòla mòrt",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgònia de coralh de botiòla mòrt murala",
  "block.minecraft.dead_bush": "Arbust mòrt",
  "block.minecraft.dead_fire_coral": "Coralh de fuòc mòrt",
  "block.minecraft.dead_fire_coral_block": "Blòc de coralh de fuòc mòrt",
  "block.minecraft.dead_fire_coral_fan": "Gorgònia de coralh de fuòc mòrt",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgònia de coralh de fuòc mòrt murala",
  "block.minecraft.dead_horn_coral": "Coralh cornut mòrt",
  "block.minecraft.dead_horn_coral_block": "Blòc de coralh cornut mòrt",
  "block.minecraft.dead_horn_coral_fan": "Gorgònia de coralh cornut mòrt",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgònia de coralh cornut mòrt murala",
  "block.minecraft.dead_tube_coral": "Coralh tubular mòrt",
  "block.minecraft.dead_tube_coral_block": "Blòc de coralh tubular mòrt",
  "block.minecraft.dead_tube_coral_fan": "Gorgònia de coralh tubular mòrt",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgònia de coralh tubular mòrt murala",
  "block.minecraft.decorated_pot": "Vas ondrat",
  "block.minecraft.deepslate": "Ardesa prigonda",
  "block.minecraft.deepslate_brick_slab": "Lausa en bricas d'ardesa prigonda",
  "block.minecraft.deepslate_brick_stairs": "Escalièrs en bricas d'ardesa prigonda",
  "block.minecraft.deepslate_brick_wall": "Muret en bricas d'ardesa prigonda",
  "block.minecraft.deepslate_bricks": "Bricas d'ardesa prigonda",
  "block.minecraft.deepslate_coal_ore": "Minièra de carbon en ardesa prigonda",
  "block.minecraft.deepslate_copper_ore": "Minièra de coire en ardesa prigonda",
  "block.minecraft.deepslate_diamond_ore": "Minièra de diamant en ardesa prigonda",
  "block.minecraft.deepslate_emerald_ore": "Minièra d'esmerauda en ardesa prigonda",
  "block.minecraft.deepslate_gold_ore": "Minièra d'aur en ardesa prigonda",
  "block.minecraft.deepslate_iron_ore": "Minièra de fèrre en ardesa prigonda",
  "block.minecraft.deepslate_lapis_ore": "Minièra de lapislazuli en ardesa prigonda",
  "block.minecraft.deepslate_redstone_ore": "Minièra de redstone en ardesa prigonda",
  "block.minecraft.deepslate_tile_slab": "Lausa en rajòlas d'ardesa prigonda",
  "block.minecraft.deepslate_tile_stairs": "Escalièrs en rajòlas d'ardesa prigonda",
  "block.minecraft.deepslate_tile_wall": "Muret en rajòlas d'ardesa prigonda",
  "block.minecraft.deepslate_tiles": "Rajòlas d'ardesa prigonda",
  "block.minecraft.detector_rail": "Ralh detector",
  "block.minecraft.diamond_block": "Blòc de diamant",
  "block.minecraft.diamond_ore": "Minièra de diamant",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Lausa de diorita",
  "block.minecraft.diorite_stairs": "Escalièrs de diorita",
  "block.minecraft.diorite_wall": "Muret de diorita",
  "block.minecraft.dirt": "Tèrra",
  "block.minecraft.dirt_path": "Camin de tèrra",
  "block.minecraft.dispenser": "Distribuïdor",
  "block.minecraft.dragon_egg": "Uòu de dragon",
  "block.minecraft.dragon_head": "Cap de dragon",
  "block.minecraft.dragon_wall_head": "Cap de dragon murau",
  "block.minecraft.dried_ghast": "Ghast secat",
  "block.minecraft.dried_kelp_block": "Blòc d'augas secadas",
  "block.minecraft.dripstone_block": "Blòc d'espeleotèma",
  "block.minecraft.dropper": "Donaire",
  "block.minecraft.emerald_block": "Blòc d'esmerauda",
  "block.minecraft.emerald_ore": "Minièra d'esmerauda",
  "block.minecraft.enchanting_table": "Taula d'encantament",
  "block.minecraft.end_gateway": "Palanca de l'End",
  "block.minecraft.end_portal": "Portau de l'End",
  "block.minecraft.end_portal_frame": "Quadre dau portau de l'End",
  "block.minecraft.end_rod": "Barra de l'End",
  "block.minecraft.end_stone": "Ròca de l'End",
  "block.minecraft.end_stone_brick_slab": "Lausa en bricas de pèira de l'End",
  "block.minecraft.end_stone_brick_stairs": "Escalièrs en bricas de pèira de l'End",
  "block.minecraft.end_stone_brick_wall": "Muret en bricas de pèira de l'End",
  "block.minecraft.end_stone_bricks": "Bricas de pèira de l'End",
  "block.minecraft.ender_chest": "Còfre d'ender",
  "block.minecraft.exposed_chiseled_copper": "Coire escultat expausat",
  "block.minecraft.exposed_copper": "Coire expausat",
  "block.minecraft.exposed_copper_bars": "Exposed Copper Bars",
  "block.minecraft.exposed_copper_bulb": "Ampola en coire expausada",
  "block.minecraft.exposed_copper_chain": "Exposed Copper Chain",
  "block.minecraft.exposed_copper_chest": "Exposed Copper Chest",
  "block.minecraft.exposed_copper_door": "Pòrta en coire expausada",
  "block.minecraft.exposed_copper_golem_statue": "Exposed Copper Golem Statue",
  "block.minecraft.exposed_copper_grate": "Grasilha en coire expausada",
  "block.minecraft.exposed_copper_lantern": "Exposed Copper Lantern",
  "block.minecraft.exposed_copper_trapdoor": "Trapa en coire expausada",
  "block.minecraft.exposed_cut_copper": "Coire talhat expausat",
  "block.minecraft.exposed_cut_copper_slab": "Lausa en coire talhada expausada",
  "block.minecraft.exposed_cut_copper_stairs": "Escalièrs en coire talhat expausat",
  "block.minecraft.exposed_lightning_rod": "Exposed Lightning Rod",
  "block.minecraft.farmland": "Tèrra laurada",
  "block.minecraft.fern": "Fauguièra",
  "block.minecraft.fire": "Fuòc",
  "block.minecraft.fire_coral": "Coralh de fuòc",
  "block.minecraft.fire_coral_block": "Blòc de coralh de fuòc",
  "block.minecraft.fire_coral_fan": "Gorgònia de coralh de fuòc",
  "block.minecraft.fire_coral_wall_fan": "Gorgònia de coralh de fuòc murala",
  "block.minecraft.firefly_bush": "Boisson a lusetas",
  "block.minecraft.fletching_table": "Taula d'arqueria",
  "block.minecraft.flower_pot": "Topin",
  "block.minecraft.flowering_azalea": "Azalèa florida",
  "block.minecraft.flowering_azalea_leaves": "Fuèlhas d'azalèa florida",
  "block.minecraft.frogspawn": "Uòus de granolha",
  "block.minecraft.frosted_ice": "Glaç gibrat",
  "block.minecraft.furnace": "Forn",
  "block.minecraft.gilded_blackstone": "Ròca negra daurada",
  "block.minecraft.glass": "Veire",
  "block.minecraft.glass_pane": "Panèu de veire",
  "block.minecraft.glow_lichen": "Liquèn luminós",
  "block.minecraft.glowstone": "Pèira luminosa",
  "block.minecraft.gold_block": "Blòc d'aur",
  "block.minecraft.gold_ore": "Minièra d'aur",
  "block.minecraft.golden_dandelion": "Golden Dandelion",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Lausa en granit",
  "block.minecraft.granite_stairs": "Escalièrs en granit",
  "block.minecraft.granite_wall": "Muret de granit",
  "block.minecraft.grass": "Èrba",
  "block.minecraft.grass_block": "Blòc d'èrba",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Bandièra grisa",
  "block.minecraft.gray_bed": "Lièch gris",
  "block.minecraft.gray_candle": "Candèla grisa",
  "block.minecraft.gray_candle_cake": "Pastís amb candèla grisa",
  "block.minecraft.gray_carpet": "Moqueta grisa",
  "block.minecraft.gray_concrete": "Beton gris",
  "block.minecraft.gray_concrete_powder": "Polsa de beton grisa",
  "block.minecraft.gray_glazed_terracotta": "Tèrra cuècha esmautada grisa",
  "block.minecraft.gray_shulker_box": "Bóstia de Shulker grisa",
  "block.minecraft.gray_stained_glass": "Veire gris",
  "block.minecraft.gray_stained_glass_pane": "Panèu de veire gris",
  "block.minecraft.gray_terracotta": "Tèrra cuècha grisa",
  "block.minecraft.gray_wool": "Lana grisa",
  "block.minecraft.green_banner": "Bandièra verda",
  "block.minecraft.green_bed": "Lièch verd",
  "block.minecraft.green_candle": "Candèla verda",
  "block.minecraft.green_candle_cake": "Pastís amb candèla verda",
  "block.minecraft.green_carpet": "Moqueta verda",
  "block.minecraft.green_concrete": "Beton verd",
  "block.minecraft.green_concrete_powder": "Polsa de beton verda",
  "block.minecraft.green_glazed_terracotta": "Tèrra cuècha esmautada verda",
  "block.minecraft.green_shulker_box": "Bóstia de Shulker verda",
  "block.minecraft.green_stained_glass": "Veire verd",
  "block.minecraft.green_stained_glass_pane": "Panèu de veire verd",
  "block.minecraft.green_terracotta": "Tèrra cuècha verda",
  "block.minecraft.green_wool": "Lana verda",
  "block.minecraft.grindstone": "Mòla",
  "block.minecraft.hanging_roots": "Raices penjants",
  "block.minecraft.hay_block": "Bala de fen",
  "block.minecraft.heavy_core": "Nuclèu pesuc",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de pression per pes elevat",
  "block.minecraft.honey_block": "Blòc de mèu",
  "block.minecraft.honeycomb_block": "Blòc de bresca",
  "block.minecraft.hopper": "Embut",
  "block.minecraft.horn_coral": "Coralh cornut",
  "block.minecraft.horn_coral_block": "Blòc de coralh cornut",
  "block.minecraft.horn_coral_fan": "Gorgònia de coralh cornut",
  "block.minecraft.horn_coral_wall_fan": "Gorgònia de coralh cornut murala",
  "block.minecraft.ice": "Glaç",
  "block.minecraft.infested_chiseled_stone_bricks": "Bricas de pèira escultada infestadas",
  "block.minecraft.infested_cobblestone": "Pèiras infestadas",
  "block.minecraft.infested_cracked_stone_bricks": "Bricas de pèira fendilhada infestadas",
  "block.minecraft.infested_deepslate": "Ardesa prigonda infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Bricas de pèira mofuda infestadas",
  "block.minecraft.infested_stone": "Ròca infestada",
  "block.minecraft.infested_stone_bricks": "Bricas de pèira infestadas",
  "block.minecraft.iron_bars": "Barrets de fèrre",
  "block.minecraft.iron_block": "Blòc de fèrre",
  "block.minecraft.iron_chain": "Iron Chain",
  "block.minecraft.iron_door": "Pòrta en fèrre",
  "block.minecraft.iron_ore": "Minièra de fèrre",
  "block.minecraft.iron_trapdoor": "Trapa en fèrre",
  "block.minecraft.jack_o_lantern": "Lantèrna coja",
  "block.minecraft.jigsaw": "Blòc copacap",
  "block.minecraft.jukebox": "Tocadisques",
  "block.minecraft.jungle_button": "Boton de jungla",
  "block.minecraft.jungle_door": "Pòrta de jungla",
  "block.minecraft.jungle_fence": "Barralha de jungla",
  "block.minecraft.jungle_fence_gate": "Pòrta de barralha de jungla",
  "block.minecraft.jungle_hanging_sign": "Pancarta penjanta de jungla",
  "block.minecraft.jungle_leaves": "Fuèlhas de jungla",
  "block.minecraft.jungle_log": "Busca de jungla",
  "block.minecraft.jungle_planks": "Plancas de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de pression de jungla",
  "block.minecraft.jungle_sapling": "Grelh de jungla",
  "block.minecraft.jungle_shelf": "Estaudèla de jungla",
  "block.minecraft.jungle_sign": "Pancarta de jungla",
  "block.minecraft.jungle_slab": "Lausa de jungla",
  "block.minecraft.jungle_stairs": "Escalièrs de jungla",
  "block.minecraft.jungle_trapdoor": "Trapa de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Pancarta penjanta de jungla murala",
  "block.minecraft.jungle_wall_sign": "Pancarta de jungla murala",
  "block.minecraft.jungle_wood": "Fusta de jungla",
  "block.minecraft.kelp": "Auga",
  "block.minecraft.kelp_plant": "Tija d'auga",
  "block.minecraft.ladder": "Escala",
  "block.minecraft.lantern": "Lantèrna",
  "block.minecraft.lapis_block": "Blòc de lapislazuli",
  "block.minecraft.lapis_ore": "Minièra de lapislazuli",
  "block.minecraft.large_amethyst_bud": "Cristau d'ametista grand",
  "block.minecraft.large_fern": "Fauguièra granda",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Pairòla de lava",
  "block.minecraft.leaf_litter": "Fuèlhas mòrtas",
  "block.minecraft.lectern": "Pupitre",
  "block.minecraft.lever": "Agre",
  "block.minecraft.light": "Lutz",
  "block.minecraft.light_blue_banner": "Bandièra blau clar",
  "block.minecraft.light_blue_bed": "Lièch blau clar",
  "block.minecraft.light_blue_candle": "Candèla blau clar",
  "block.minecraft.light_blue_candle_cake": "Pastís amb candèla blau clar",
  "block.minecraft.light_blue_carpet": "Moqueta blau clar",
  "block.minecraft.light_blue_concrete": "Beton blau clar",
  "block.minecraft.light_blue_concrete_powder": "Polsa de beton blau clar",
  "block.minecraft.light_blue_glazed_terracotta": "Tèrra cuècha esmautada blau clar",
  "block.minecraft.light_blue_shulker_box": "Bóstia de shulker blau clar",
  "block.minecraft.light_blue_stained_glass": "Veire blau clar",
  "block.minecraft.light_blue_stained_glass_pane": "Panèu de veire blau clar",
  "block.minecraft.light_blue_terracotta": "Tèrra cuècha blau clar",
  "block.minecraft.light_blue_wool": "Lana blau clar",
  "block.minecraft.light_gray_banner": "Bandièra gris clar",
  "block.minecraft.light_gray_bed": "Lièch gris clar",
  "block.minecraft.light_gray_candle": "Candèla gris clar",
  "block.minecraft.light_gray_candle_cake": "Pastís amb candèla gris clar",
  "block.minecraft.light_gray_carpet": "Moqueta gris clar",
  "block.minecraft.light_gray_concrete": "Beton gris clar",
  "block.minecraft.light_gray_concrete_powder": "Polsa de beton gris clar",
  "block.minecraft.light_gray_glazed_terracotta": "Tèrra cuècha esmautada gris clar",
  "block.minecraft.light_gray_shulker_box": "Bóstia de Shulker gris clar",
  "block.minecraft.light_gray_stained_glass": "Veire gris clar",
  "block.minecraft.light_gray_stained_glass_pane": "Panèu de veire gris clar",
  "block.minecraft.light_gray_terracotta": "Tèrra cuècha gris clar",
  "block.minecraft.light_gray_wool": "Lana gris clar",
  "block.minecraft.light_weighted_pressure_plate": "Placa de pression per pes leugièr",
  "block.minecraft.lightning_rod": "Paratron",
  "block.minecraft.lilac": "Lillac",
  "block.minecraft.lily_of_the_valley": "Muguet",
  "block.minecraft.lily_pad": "Nimfèia",
  "block.minecraft.lime_banner": "Bandièra lima",
  "block.minecraft.lime_bed": "Lièch lima",
  "block.minecraft.lime_candle": "Candèla lima",
  "block.minecraft.lime_candle_cake": "Pastís amb candèla blanca",
  "block.minecraft.lime_carpet": "Moqueta lima",
  "block.minecraft.lime_concrete": "Beton lima",
  "block.minecraft.lime_concrete_powder": "Polsa de beton lima",
  "block.minecraft.lime_glazed_terracotta": "Tèrra cuècha esmautada lima",
  "block.minecraft.lime_shulker_box": "Bóstia de Shulker verd clar",
  "block.minecraft.lime_stained_glass": "Veire lima",
  "block.minecraft.lime_stained_glass_pane": "Panèu de veire lima",
  "block.minecraft.lime_terracotta": "Tèrra cuècha verd clar",
  "block.minecraft.lime_wool": "Lana lima",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Telièr",
  "block.minecraft.magenta_banner": "Bandièra magenta",
  "block.minecraft.magenta_bed": "Lièch magenta",
  "block.minecraft.magenta_candle": "Candèla magenta",
  "block.minecraft.magenta_candle_cake": "Pastís amb candèla magenta",
  "block.minecraft.magenta_carpet": "Moqueta magenta",
  "block.minecraft.magenta_concrete": "Beton magenta",
  "block.minecraft.magenta_concrete_powder": "Polsa de beton magenta",
  "block.minecraft.magenta_glazed_terracotta": "Tèrra cuècha esmautada magenta",
  "block.minecraft.magenta_shulker_box": "Bóstia de Shulker magenta",
  "block.minecraft.magenta_stained_glass": "Veire magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panèu de veire magenta",
  "block.minecraft.magenta_terracotta": "Tèrra cuècha magenta",
  "block.minecraft.magenta_wool": "Lana magenta",
  "block.minecraft.magma_block": "Blòc de magma",
  "block.minecraft.mangrove_button": "Boton en manglièr",
  "block.minecraft.mangrove_door": "Pòrta en manglièr",
  "block.minecraft.mangrove_fence": "Barralha en manglièr",
  "block.minecraft.mangrove_fence_gate": "Pòrta de barralha en manglièr",
  "block.minecraft.mangrove_hanging_sign": "Pancarta penjanta en manglièr",
  "block.minecraft.mangrove_leaves": "Fuèlhas de manglièr",
  "block.minecraft.mangrove_log": "Busca de manglièr",
  "block.minecraft.mangrove_planks": "Plancas de manglièr",
  "block.minecraft.mangrove_pressure_plate": "Placa de pression en manglièr",
  "block.minecraft.mangrove_propagule": "Propagula de manglièr",
  "block.minecraft.mangrove_roots": "Raices de manglièr",
  "block.minecraft.mangrove_shelf": "Estaudèla en manglièr",
  "block.minecraft.mangrove_sign": "Pancarta en manglièr",
  "block.minecraft.mangrove_slab": "Lausa en manglièr",
  "block.minecraft.mangrove_stairs": "Escalièrs en manglièr",
  "block.minecraft.mangrove_trapdoor": "Trapa en manglièr",
  "block.minecraft.mangrove_wall_hanging_sign": "Pancarta penjanta en manglièr murala",
  "block.minecraft.mangrove_wall_sign": "Pancarta en manglièr murala",
  "block.minecraft.mangrove_wood": "Fusta de manglièr",
  "block.minecraft.medium_amethyst_bud": "Cristau d'ametista mejan",
  "block.minecraft.melon": "Pastèca",
  "block.minecraft.melon_stem": "Tija de pastèca",
  "block.minecraft.moss_block": "Blòc de mofa",
  "block.minecraft.moss_carpet": "Moqueta de mofa",
  "block.minecraft.mossy_cobblestone": "Pèiras mofudas",
  "block.minecraft.mossy_cobblestone_slab": "Lausa de pèiras mofudas",
  "block.minecraft.mossy_cobblestone_stairs": "Escalièrs en pèiras mofudas",
  "block.minecraft.mossy_cobblestone_wall": "Mur de pèiras mofudas",
  "block.minecraft.mossy_stone_brick_slab": "Lausa en bricas de pèiras mofudas",
  "block.minecraft.mossy_stone_brick_stairs": "Escalièrs en bricas de pèiras mofudas",
  "block.minecraft.mossy_stone_brick_wall": "Muret en bricas de pèiras mofudas",
  "block.minecraft.mossy_stone_bricks": "Bricas de pèira mofudas",
  "block.minecraft.moving_piston": "Piston en moviment",
  "block.minecraft.mud": "Fanga",
  "block.minecraft.mud_brick_slab": "Lausa en bricas de fanga",
  "block.minecraft.mud_brick_stairs": "Escalièrs en bricas de fanga",
  "block.minecraft.mud_brick_wall": "Muret en bricas de fanga",
  "block.minecraft.mud_bricks": "Bricas de fanga",
  "block.minecraft.muddy_mangrove_roots": "Raices de manglièr fangoses",
  "block.minecraft.mushroom_stem": "Tija de camparòu",
  "block.minecraft.mycelium": "Micèli",
  "block.minecraft.nether_brick_fence": "Barralha en bricas dau Nether",
  "block.minecraft.nether_brick_slab": "Lausa en bricas dau Nether",
  "block.minecraft.nether_brick_stairs": "Escalièrs en bricas dau Nether",
  "block.minecraft.nether_brick_wall": "Muret en bricas dau Nether",
  "block.minecraft.nether_bricks": "Bricas dau Nether",
  "block.minecraft.nether_gold_ore": "Minièra d'aur dau Nether",
  "block.minecraft.nether_portal": "Portau dau Nether",
  "block.minecraft.nether_quartz_ore": "Minièra de qüars dau Nether",
  "block.minecraft.nether_sprouts": "Brots dau Nether",
  "block.minecraft.nether_wart": "Verruga dau Nether",
  "block.minecraft.nether_wart_block": "Blòc de botiòlas dau Nether",
  "block.minecraft.netherite_block": "Blòc de netherita",
  "block.minecraft.netherrack": "Ròca dau Nether",
  "block.minecraft.note_block": "Blòc musicau",
  "block.minecraft.oak_button": "Boton en euse",
  "block.minecraft.oak_door": "Pòrta en euse",
  "block.minecraft.oak_fence": "Barralha en euse",
  "block.minecraft.oak_fence_gate": "Pòrta de barralha en euse",
  "block.minecraft.oak_hanging_sign": "Pancarta penjanta en euse",
  "block.minecraft.oak_leaves": "Fuèlhas d'euse",
  "block.minecraft.oak_log": "Busca d'euse",
  "block.minecraft.oak_planks": "Plancas d'euse",
  "block.minecraft.oak_pressure_plate": "Placa de pression en euse",
  "block.minecraft.oak_sapling": "Grelh d'euse",
  "block.minecraft.oak_shelf": "Estaudèla en euse",
  "block.minecraft.oak_sign": "Pancarta en euse",
  "block.minecraft.oak_slab": "Lausa en euse",
  "block.minecraft.oak_stairs": "Escalièrs en euse",
  "block.minecraft.oak_trapdoor": "Trapa en euse",
  "block.minecraft.oak_wall_hanging_sign": "Pancarta penjanta en euse murala",
  "block.minecraft.oak_wall_sign": "Pancarta en euse murala",
  "block.minecraft.oak_wood": "Fusta d'euse",
  "block.minecraft.observer": "Observator",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Granolum òcre",
  "block.minecraft.ominous_banner": "Bandièra ominosa",
  "block.minecraft.open_eyeblossom": "Uèlhquidèa obèrta",
  "block.minecraft.orange_banner": "Bandièra iranja",
  "block.minecraft.orange_bed": "Lièch irange",
  "block.minecraft.orange_candle": "Candèla iranja",
  "block.minecraft.orange_candle_cake": "Pastís amb candèla iranja",
  "block.minecraft.orange_carpet": "Moqueta iranja",
  "block.minecraft.orange_concrete": "Beton irange",
  "block.minecraft.orange_concrete_powder": "Polsa de beton iranja",
  "block.minecraft.orange_glazed_terracotta": "Tèrra cuècha esmautada iranja",
  "block.minecraft.orange_shulker_box": "Bóstia de Shulker iranja",
  "block.minecraft.orange_stained_glass": "Veire irange",
  "block.minecraft.orange_stained_glass_pane": "Panèu de veire irange",
  "block.minecraft.orange_terracotta": "Tèrra cuècha iranja",
  "block.minecraft.orange_tulip": "Tulipa iranja",
  "block.minecraft.orange_wool": "Lana iranja",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Coire escultat oxidat",
  "block.minecraft.oxidized_copper": "Coire oxidat",
  "block.minecraft.oxidized_copper_bars": "Oxidized Copper Bars",
  "block.minecraft.oxidized_copper_bulb": "Ampola en coire oxidada",
  "block.minecraft.oxidized_copper_chain": "Oxidized Copper Chain",
  "block.minecraft.oxidized_copper_chest": "Oxidized Copper Chest",
  "block.minecraft.oxidized_copper_door": "Pòrta en coire oxidada",
  "block.minecraft.oxidized_copper_golem_statue": "Oxidized Copper Golem Statue",
  "block.minecraft.oxidized_copper_grate": "Grasilha en coire oxidada",
  "block.minecraft.oxidized_copper_lantern": "Oxidized Copper Lantern",
  "block.minecraft.oxidized_copper_trapdoor": "Trapa en coire oxidada",
  "block.minecraft.oxidized_cut_copper": "Coire talhat oxidat",
  "block.minecraft.oxidized_cut_copper_slab": "Lausa en coire talhada oxidada",
  "block.minecraft.oxidized_cut_copper_stairs": "Escalièrs en coire talhat oxidat",
  "block.minecraft.oxidized_lightning_rod": "Oxidized Lightning Rod",
  "block.minecraft.packed_ice": "Glaç compactat",
  "block.minecraft.packed_mud": "Fanga compactada",
  "block.minecraft.pale_hanging_moss": "Mofa palla penjanta",
  "block.minecraft.pale_moss_block": "Blòc de mofa palla",
  "block.minecraft.pale_moss_carpet": "Moqueta de mofa palla",
  "block.minecraft.pale_oak_button": "Boton en euse palle",
  "block.minecraft.pale_oak_door": "Pòrta en euse palle",
  "block.minecraft.pale_oak_fence": "Barralha en euse palle",
  "block.minecraft.pale_oak_fence_gate": "Pòrta de barralha en euse palle",
  "block.minecraft.pale_oak_hanging_sign": "Pancarta penjanta en euse palle",
  "block.minecraft.pale_oak_leaves": "Fuèlhas d'euse palle",
  "block.minecraft.pale_oak_log": "Busca d'euse palle",
  "block.minecraft.pale_oak_planks": "Plancas d'euse palle",
  "block.minecraft.pale_oak_pressure_plate": "Placa de pression en euse palle",
  "block.minecraft.pale_oak_sapling": "Grelh d'euse palle",
  "block.minecraft.pale_oak_shelf": "Estaudèla en euse palle",
  "block.minecraft.pale_oak_sign": "Pancarta en euse palle",
  "block.minecraft.pale_oak_slab": "Lausa en euse palle",
  "block.minecraft.pale_oak_stairs": "Escalièrs en euse palle",
  "block.minecraft.pale_oak_trapdoor": "Trapa en euse palle",
  "block.minecraft.pale_oak_wall_hanging_sign": "Pancarta penjanta en euse palle murala",
  "block.minecraft.pale_oak_wall_sign": "Pancarta en euse palle murala",
  "block.minecraft.pale_oak_wood": "Fusta d'euse palle",
  "block.minecraft.pearlescent_froglight": "Granolum nacrat",
  "block.minecraft.peony": "Peuna",
  "block.minecraft.petrified_oak_slab": "Lausa en euse petrificada",
  "block.minecraft.piglin_head": "Cap de piglin",
  "block.minecraft.piglin_wall_head": "Cap de piglin mural",
  "block.minecraft.pink_banner": "Bandièra ròsa",
  "block.minecraft.pink_bed": "Lièch ròse",
  "block.minecraft.pink_candle": "Candèla ròsa",
  "block.minecraft.pink_candle_cake": "Pastís amb candèla ròsa",
  "block.minecraft.pink_carpet": "Moqueta ròsa",
  "block.minecraft.pink_concrete": "Beton ròse",
  "block.minecraft.pink_concrete_powder": "Polsa de beton ròsa",
  "block.minecraft.pink_glazed_terracotta": "Tèrra cuècha esmautada ròsa",
  "block.minecraft.pink_petals": "Petals ròses",
  "block.minecraft.pink_shulker_box": "Bóstia de Shulker ròsa",
  "block.minecraft.pink_stained_glass": "Veire ròse",
  "block.minecraft.pink_stained_glass_pane": "Panèu de veire ròse",
  "block.minecraft.pink_terracotta": "Tèrra cuècha ròsa",
  "block.minecraft.pink_tulip": "Tulipa ròsa",
  "block.minecraft.pink_wool": "Lana ròsa",
  "block.minecraft.piston": "Piston",
  "block.minecraft.piston_head": "Cap de piston",
  "block.minecraft.pitcher_crop": "Plançon de planta jarra",
  "block.minecraft.pitcher_plant": "Planta jarra",
  "block.minecraft.player_head": "Cap de jogaire",
  "block.minecraft.player_head.named": "Cap de %s",
  "block.minecraft.player_wall_head": "Cap de jogaire murau",
  "block.minecraft.podzol": "Podzòl",
  "block.minecraft.pointed_dripstone": "Espeleotèma ponchuda",
  "block.minecraft.polished_andesite": "Andesita polida",
  "block.minecraft.polished_andesite_slab": "Lausa d'andesita polida",
  "block.minecraft.polished_andesite_stairs": "Escalièrs d'andesita polida",
  "block.minecraft.polished_basalt": "Basalte polit",
  "block.minecraft.polished_blackstone": "Ròca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "Lausa en bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escalièrs en bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "Muret en bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_bricks": "Bricas de ròca negra polida",
  "block.minecraft.polished_blackstone_button": "Boton de ròca negra polida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de pression en ròca negra polida",
  "block.minecraft.polished_blackstone_slab": "Lausa de ròca negra polida",
  "block.minecraft.polished_blackstone_stairs": "Escalièrs de ròca negra polida",
  "block.minecraft.polished_blackstone_wall": "Muret de ròca negra polida",
  "block.minecraft.polished_deepslate": "Ardesa prigonda polida",
  "block.minecraft.polished_deepslate_slab": "Lausa en ardesa prigonda polida",
  "block.minecraft.polished_deepslate_stairs": "Escalièrs en ardesa prigonda polida",
  "block.minecraft.polished_deepslate_wall": "Muret en ardesa prigonda polida",
  "block.minecraft.polished_diorite": "Diorita polida",
  "block.minecraft.polished_diorite_slab": "Lausa en diorita polida",
  "block.minecraft.polished_diorite_stairs": "Escalièrs en diorit polida",
  "block.minecraft.polished_granite": "Granit polit",
  "block.minecraft.polished_granite_slab": "Lausa en granit polit",
  "block.minecraft.polished_granite_stairs": "Escalièrs en granit polit",
  "block.minecraft.polished_tuff": "Tuf polit",
  "block.minecraft.polished_tuff_slab": "Lausa de tuf polit",
  "block.minecraft.polished_tuff_stairs": "Escalièrs de tuf polit",
  "block.minecraft.polished_tuff_wall": "Mur de tuf polit",
  "block.minecraft.poppy": "Rosèla",
  "block.minecraft.potatoes": "Patanas",
  "block.minecraft.potted_acacia_sapling": "Grelh de cacièr en pòt",
  "block.minecraft.potted_allium": "Allium en pòt",
  "block.minecraft.potted_azalea_bush": "Azalèa en pòt",
  "block.minecraft.potted_azure_bluet": "Houstonia caerulea en pòt",
  "block.minecraft.potted_bamboo": "Bambó en pòt",
  "block.minecraft.potted_birch_sapling": "Grelh de bèç en pòt",
  "block.minecraft.potted_blue_orchid": "Orquidèa blava en pòt",
  "block.minecraft.potted_brown_mushroom": "Camparòu brun en pòt",
  "block.minecraft.potted_cactus": "Cactus en pòt",
  "block.minecraft.potted_cherry_sapling": "Grelh de cerièis en pòt",
  "block.minecraft.potted_closed_eyeblossom": "Uèlhquidèa obèrta en pot",
  "block.minecraft.potted_cornflower": "Blavet en pòt",
  "block.minecraft.potted_crimson_fungus": "Fonge cremesin en pòt",
  "block.minecraft.potted_crimson_roots": "Raices cremesins en pòt",
  "block.minecraft.potted_dandelion": "Pissalach en pòt",
  "block.minecraft.potted_dark_oak_sapling": "Euse escur en pòt",
  "block.minecraft.potted_dead_bush": "Arbust mòrt en pòt",
  "block.minecraft.potted_fern": "Fauguièra en pòt",
  "block.minecraft.potted_flowering_azalea_bush": "Azalèa florida en pòt",
  "block.minecraft.potted_golden_dandelion": "Potted Golden Dandelion",
  "block.minecraft.potted_jungle_sapling": "Grelh de jungla en pòt",
  "block.minecraft.potted_lily_of_the_valley": "Muguet en pòt",
  "block.minecraft.potted_mangrove_propagule": "Propagula de manglièr en pòt",
  "block.minecraft.potted_oak_sapling": "Euse en pòt",
  "block.minecraft.potted_open_eyeblossom": "Uèlhquidèa barrata en pot",
  "block.minecraft.potted_orange_tulip": "Tulipa iranja en pòt",
  "block.minecraft.potted_oxeye_daisy": "Margarida en pòt",
  "block.minecraft.potted_pale_oak_sapling": "Euse palle en pòt",
  "block.minecraft.potted_pink_tulip": "Tulipa ròsa en pòt",
  "block.minecraft.potted_poppy": "Rosèla en pòt",
  "block.minecraft.potted_red_mushroom": "Camparòu roge en pòt",
  "block.minecraft.potted_red_tulip": "Tulipa roja en pòt",
  "block.minecraft.potted_spruce_sapling": "Grelh d'avet en pòt",
  "block.minecraft.potted_torchflower": "Entòrcha-flor en pot",
  "block.minecraft.potted_warped_fungus": "Fonge bescornut en pòt",
  "block.minecraft.potted_warped_roots": "Raices bescornuts en pòt",
  "block.minecraft.potted_white_tulip": "Tulipa blanca en pòt",
  "block.minecraft.potted_wither_rose": "Ròsa de wither en pòt",
  "block.minecraft.powder_snow": "Nèu polverosa",
  "block.minecraft.powder_snow_cauldron": "Pairòla de nèu polverosa",
  "block.minecraft.powered_rail": "Ralh propulsor",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Lausa en bricas de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escalièrs en bricas de prismarina",
  "block.minecraft.prismarine_bricks": "Bricas de prismarina",
  "block.minecraft.prismarine_slab": "Lausa de prismarina",
  "block.minecraft.prismarine_stairs": "Escalièrs en prismarina",
  "block.minecraft.prismarine_wall": "Muret de prismarina",
  "block.minecraft.pumpkin": "Coja",
  "block.minecraft.pumpkin_stem": "Tija de coja",
  "block.minecraft.purple_banner": "Bandièra violeta",
  "block.minecraft.purple_bed": "Lièch violet",
  "block.minecraft.purple_candle": "Candèla violeta",
  "block.minecraft.purple_candle_cake": "Pastís amb candèla violeta",
  "block.minecraft.purple_carpet": "Moqueta violeta",
  "block.minecraft.purple_concrete": "Beton violet",
  "block.minecraft.purple_concrete_powder": "Polsa de beton violeta",
  "block.minecraft.purple_glazed_terracotta": "Tèrra cuècha esmautada violeta",
  "block.minecraft.purple_shulker_box": "Bóstia de Shulker violeta",
  "block.minecraft.purple_stained_glass": "Veire violet",
  "block.minecraft.purple_stained_glass_pane": "Panèu de veire violet",
  "block.minecraft.purple_terracotta": "Tèrra cuècha violeta",
  "block.minecraft.purple_wool": "Lana violeta",
  "block.minecraft.purpur_block": "Blòc de porpra",
  "block.minecraft.purpur_pillar": "Pilar de porpra",
  "block.minecraft.purpur_slab": "Lausa de porpra",
  "block.minecraft.purpur_stairs": "Escalièrs de porpra",
  "block.minecraft.quartz_block": "Blòc de qüars",
  "block.minecraft.quartz_bricks": "Bricas de qüars",
  "block.minecraft.quartz_pillar": "Pilar de qüars",
  "block.minecraft.quartz_slab": "Lausa en qüars",
  "block.minecraft.quartz_stairs": "Escalièrs en qüars",
  "block.minecraft.rail": "Ralh",
  "block.minecraft.raw_copper_block": "Blòc de coire brut",
  "block.minecraft.raw_gold_block": "Blòc d'aur brut",
  "block.minecraft.raw_iron_block": "Blòc de fèrre brut",
  "block.minecraft.red_banner": "Bandièra roja",
  "block.minecraft.red_bed": "Lièch roge",
  "block.minecraft.red_candle": "Candèla roja",
  "block.minecraft.red_candle_cake": "Pastís amb candèla roja",
  "block.minecraft.red_carpet": "Moqueta roja",
  "block.minecraft.red_concrete": "Beton roge",
  "block.minecraft.red_concrete_powder": "Polsa de beton roja",
  "block.minecraft.red_glazed_terracotta": "Tèrra cuècha esmautada roja",
  "block.minecraft.red_mushroom": "Camparòu roge",
  "block.minecraft.red_mushroom_block": "Blòc de camparòu roge",
  "block.minecraft.red_nether_brick_slab": "Lausa en bricas dau Nether rojas",
  "block.minecraft.red_nether_brick_stairs": "Escalièrs en bricas dau Nether rojas",
  "block.minecraft.red_nether_brick_wall": "Muret en bricas dau Nether rojas",
  "block.minecraft.red_nether_bricks": "Bricas dau Nether rojas",
  "block.minecraft.red_sand": "Sabla roja",
  "block.minecraft.red_sandstone": "Gres roge",
  "block.minecraft.red_sandstone_slab": "Lausa de gres roge",
  "block.minecraft.red_sandstone_stairs": "Escalièrs en gres roge",
  "block.minecraft.red_sandstone_wall": "Muret de gres roge",
  "block.minecraft.red_shulker_box": "Bóstia de Shulker roja",
  "block.minecraft.red_stained_glass": "Veire roge",
  "block.minecraft.red_stained_glass_pane": "Panèu de veire roge",
  "block.minecraft.red_terracotta": "Tèrra cuècha roja",
  "block.minecraft.red_tulip": "Tulipa roja",
  "block.minecraft.red_wool": "Lana roja",
  "block.minecraft.redstone_block": "Blòc de redstone",
  "block.minecraft.redstone_lamp": "Lum de redstone",
  "block.minecraft.redstone_ore": "Minièra de redstone",
  "block.minecraft.redstone_torch": "Entòrcha de redstone",
  "block.minecraft.redstone_wall_torch": "Entòrcha de redstone murala",
  "block.minecraft.redstone_wire": "Fiau de redstone",
  "block.minecraft.reinforced_deepslate": "Ardesa prigonda renforçada",
  "block.minecraft.repeater": "Repetidor de redstone",
  "block.minecraft.repeating_command_block": "Blòc de comandas a repeticion",
  "block.minecraft.resin_block": "Blòc de resina",
  "block.minecraft.resin_brick_slab": "Lausa en bricas de resina",
  "block.minecraft.resin_brick_stairs": "Escalièrs en bricas de resina",
  "block.minecraft.resin_brick_wall": "Muret en bricas de resina",
  "block.minecraft.resin_bricks": "Bricas de resina",
  "block.minecraft.resin_clump": "Grumèl de resina",
  "block.minecraft.respawn_anchor": "Ancora de reaparicion",
  "block.minecraft.rooted_dirt": "Tèrra racinosa",
  "block.minecraft.rose_bush": "Rosièr",
  "block.minecraft.sand": "Sabla",
  "block.minecraft.sandstone": "Gres",
  "block.minecraft.sandstone_slab": "Lausa de gres",
  "block.minecraft.sandstone_stairs": "Escalièrs en gres",
  "block.minecraft.sandstone_wall": "Muret de gres",
  "block.minecraft.scaffolding": "Enart",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalisaire de sculk",
  "block.minecraft.sculk_sensor": "Captaire sculk",
  "block.minecraft.sculk_shrieker": "Udolaire sculk",
  "block.minecraft.sculk_vein": "Vena de sculk",
  "block.minecraft.sea_lantern": "Lantèrna marina",
  "block.minecraft.sea_pickle": "Cornisson de mar",
  "block.minecraft.seagrass": "Èrba marina",
  "block.minecraft.set_spawn": "Ponch de reaparicion definit",
  "block.minecraft.short_dry_grass": "Èrba corta seca",
  "block.minecraft.short_grass": "Èrba corta",
  "block.minecraft.shroomlight": "Lamparòu",
  "block.minecraft.shulker_box": "Bóstia de Shulker",
  "block.minecraft.skeleton_skull": "Cran d'esqueleta",
  "block.minecraft.skeleton_wall_skull": "Cran d'esqueleta murau",
  "block.minecraft.slime_block": "Blòc de Slime",
  "block.minecraft.small_amethyst_bud": "Cristau d'ametista pichon",
  "block.minecraft.small_dripleaf": "Gotafuèlha pichona",
  "block.minecraft.smithing_table": "Taula de fargatge",
  "block.minecraft.smoker": "Fumador",
  "block.minecraft.smooth_basalt": "Basalte lis",
  "block.minecraft.smooth_quartz": "Blòc de qüars lis",
  "block.minecraft.smooth_quartz_slab": "Lausa en qüars lis",
  "block.minecraft.smooth_quartz_stairs": "Escalièrs en qüars lis",
  "block.minecraft.smooth_red_sandstone": "Gres roge lis",
  "block.minecraft.smooth_red_sandstone_slab": "Lausa en gres roge lis",
  "block.minecraft.smooth_red_sandstone_stairs": "Escalièrs en gres roge lis",
  "block.minecraft.smooth_sandstone": "Gres lis",
  "block.minecraft.smooth_sandstone_slab": "Lausa en gres lis",
  "block.minecraft.smooth_sandstone_stairs": "Escalièrs en gres lis",
  "block.minecraft.smooth_stone": "Ròca lisa",
  "block.minecraft.smooth_stone_slab": "Lausa de ròca lisa",
  "block.minecraft.sniffer_egg": "Uòu de niflaire",
  "block.minecraft.snow": "Nèu",
  "block.minecraft.snow_block": "Blòc de nèu",
  "block.minecraft.soul_campfire": "Fuòc de camp d'anmas",
  "block.minecraft.soul_fire": "Fuòc d'anmas",
  "block.minecraft.soul_lantern": "Lantèrna d'anmas",
  "block.minecraft.soul_sand": "Sabla d'anmas",
  "block.minecraft.soul_soil": "Sòu d'anmas",
  "block.minecraft.soul_torch": "Entòrcha d'anmas",
  "block.minecraft.soul_wall_torch": "Entòrcha d'anmas murala",
  "block.minecraft.spawn.not_valid": "Avètz pas de lièch o d'ancora de reaparicion cargada, o lo blòc es estat obstruït",
  "block.minecraft.spawner": "Generator de Mostres",
  "block.minecraft.spawner.desc1": "Interaccion amb un uòu d'aparicion :",
  "block.minecraft.spawner.desc2": "Definís lo tipe de creatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor sporifèra",
  "block.minecraft.spruce_button": "Boton en avet",
  "block.minecraft.spruce_door": "Pòrta en avet",
  "block.minecraft.spruce_fence": "Barralha en avet",
  "block.minecraft.spruce_fence_gate": "Pòrta de barralha en avet",
  "block.minecraft.spruce_hanging_sign": "Pancarta penjanta en avet",
  "block.minecraft.spruce_leaves": "Fuèlhas d'avet",
  "block.minecraft.spruce_log": "Busca d'avet",
  "block.minecraft.spruce_planks": "Plancas d'avet",
  "block.minecraft.spruce_pressure_plate": "Placa de pression en avet",
  "block.minecraft.spruce_sapling": "Grelh d'avet",
  "block.minecraft.spruce_shelf": "Estaudèla en avet",
  "block.minecraft.spruce_sign": "Pancarta en avet",
  "block.minecraft.spruce_slab": "Lausa en avet",
  "block.minecraft.spruce_stairs": "Escalièrs en avet",
  "block.minecraft.spruce_trapdoor": "Trapa en avet",
  "block.minecraft.spruce_wall_hanging_sign": "Pancarta penjanta en avet murala",
  "block.minecraft.spruce_wall_sign": "Pancarta en avet murala",
  "block.minecraft.spruce_wood": "Fusta d'avet",
  "block.minecraft.sticky_piston": "Piston pegós",
  "block.minecraft.stone": "Ròca",
  "block.minecraft.stone_brick_slab": "Lausa en bricas de pèira",
  "block.minecraft.stone_brick_stairs": "Escalièrs en bricas de pèira",
  "block.minecraft.stone_brick_wall": "Muret en bricas de pèira",
  "block.minecraft.stone_bricks": "Bricas de pèira",
  "block.minecraft.stone_button": "Boton en pèira",
  "block.minecraft.stone_pressure_plate": "Placa de pression en ròca",
  "block.minecraft.stone_slab": "Lausa de ròca",
  "block.minecraft.stone_stairs": "Escalièrs de ròca",
  "block.minecraft.stonecutter": "Peirièr",
  "block.minecraft.stripped_acacia_log": "Busca de cacièr deruschada",
  "block.minecraft.stripped_acacia_wood": "Fusta de cacièr deruschada",
  "block.minecraft.stripped_bamboo_block": "Blòc de bambó desruscat",
  "block.minecraft.stripped_birch_log": "Busca de bèç deruschada",
  "block.minecraft.stripped_birch_wood": "Fusta de bèç deruschada",
  "block.minecraft.stripped_cherry_log": "Busca de cerièis desruscada",
  "block.minecraft.stripped_cherry_wood": "Fusta de cerièis desruscada",
  "block.minecraft.stripped_crimson_hyphae": "Ifas cremesinas deruschadas",
  "block.minecraft.stripped_crimson_stem": "Tija cremesina deruschada",
  "block.minecraft.stripped_dark_oak_log": "Busca d'euse escur deruschada",
  "block.minecraft.stripped_dark_oak_wood": "Fusta d'euse escur deruschada",
  "block.minecraft.stripped_jungle_log": "Busca de jungla deruschada",
  "block.minecraft.stripped_jungle_wood": "Fusta de jungla deruschada",
  "block.minecraft.stripped_mangrove_log": "Busca de manglièr deruschada",
  "block.minecraft.stripped_mangrove_wood": "Fusta de manglièr deruschada",
  "block.minecraft.stripped_oak_log": "Busca d'euse deruschada",
  "block.minecraft.stripped_oak_wood": "Fusta d'euse deruschada",
  "block.minecraft.stripped_pale_oak_log": "Busca d'euse palle deruschada",
  "block.minecraft.stripped_pale_oak_wood": "Fusta d'euse palle deruschada",
  "block.minecraft.stripped_spruce_log": "Busca d'avet deruschada",
  "block.minecraft.stripped_spruce_wood": "Fusta d'avet deruschada",
  "block.minecraft.stripped_warped_hyphae": "Ifas bescornudas deruschadas",
  "block.minecraft.stripped_warped_stem": "Tija bescornuda deruschada",
  "block.minecraft.structure_block": "Blòc d'Estructura",
  "block.minecraft.structure_void": "Void d'estructura",
  "block.minecraft.sugar_cane": "Cana de sucre",
  "block.minecraft.sunflower": "Virasolelh",
  "block.minecraft.suspicious_gravel": "Grava suspècta",
  "block.minecraft.suspicious_sand": "Sabla suspècta",
  "block.minecraft.sweet_berry_bush": "Arbust de bagas doças",
  "block.minecraft.tall_dry_grass": "Èrba nauta seca",
  "block.minecraft.tall_grass": "Èrba nauta",
  "block.minecraft.tall_seagrass": "Èrba marina nauta",
  "block.minecraft.target": "Buta",
  "block.minecraft.terracotta": "Tèrra cuècha",
  "block.minecraft.test_block": "Bloc de tèst",
  "block.minecraft.test_instance_block": "Bloc d'instància de tèst",
  "block.minecraft.tinted_glass": "Veire tintat",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Las explosions de TNT son pas activadas",
  "block.minecraft.torch": "Entòrcha",
  "block.minecraft.torchflower": "Entòrcha-flor",
  "block.minecraft.torchflower_crop": "Plançon d'entòrcha-flor",
  "block.minecraft.trapped_chest": "Còfre trapa",
  "block.minecraft.trial_spawner": "Generator de las espròvas",
  "block.minecraft.tripwire": "Còrda",
  "block.minecraft.tripwire_hook": "Cròc",
  "block.minecraft.tube_coral": "Coralh tubular",
  "block.minecraft.tube_coral_block": "Blòc de coralh tubular",
  "block.minecraft.tube_coral_fan": "Gorgònia de coralh tubular",
  "block.minecraft.tube_coral_wall_fan": "Gorgònia de coralh tubular murala",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Lausa en bricas de tuf",
  "block.minecraft.tuff_brick_stairs": "Escalièrs en bricas de tuf",
  "block.minecraft.tuff_brick_wall": "Muret en bricas de tuf",
  "block.minecraft.tuff_bricks": "Bricas de tuf",
  "block.minecraft.tuff_slab": "Lausa de tuf",
  "block.minecraft.tuff_stairs": "Escalièrs de tuf",
  "block.minecraft.tuff_wall": "Mur de tuf",
  "block.minecraft.turtle_egg": "Uòu de tartuga",
  "block.minecraft.twisting_vines": "Lianas torsadas",
  "block.minecraft.twisting_vines_plant": "Planta de lianas torsadas",
  "block.minecraft.vault": "Còfrefòrt",
  "block.minecraft.verdant_froglight": "Granolum verdós",
  "block.minecraft.vine": "Lianas",
  "block.minecraft.void_air": "Aire dau void",
  "block.minecraft.wall_torch": "Entòrcha murala",
  "block.minecraft.warped_button": "Buton bescornut",
  "block.minecraft.warped_door": "Pòrta bescornuda",
  "block.minecraft.warped_fence": "Barralha bescornuda",
  "block.minecraft.warped_fence_gate": "Pòrta de barralha bescornuda",
  "block.minecraft.warped_fungus": "Fonge bescornut",
  "block.minecraft.warped_hanging_sign": "Pancarta penjanta bescornuda",
  "block.minecraft.warped_hyphae": "Ifas bescornudas",
  "block.minecraft.warped_nylium": "Nicèli bescornut",
  "block.minecraft.warped_planks": "Plancas bescornudas",
  "block.minecraft.warped_pressure_plate": "Placa de pression bescornuda",
  "block.minecraft.warped_roots": "Raices bescornuts",
  "block.minecraft.warped_shelf": "Estaudèla bescornuda",
  "block.minecraft.warped_sign": "Pancarta bescornuda",
  "block.minecraft.warped_slab": "Lausa bescornuda",
  "block.minecraft.warped_stairs": "Escalièrs bescornuts",
  "block.minecraft.warped_stem": "Tija bescornuda",
  "block.minecraft.warped_trapdoor": "Trapa bescornuda",
  "block.minecraft.warped_wall_hanging_sign": "Pancarta penjanta bescornuda murala",
  "block.minecraft.warped_wall_sign": "Pancarta bescornuda murala",
  "block.minecraft.warped_wart_block": "Blòc de botiòlas bescornudas dau Nether",
  "block.minecraft.water": "Aiga",
  "block.minecraft.water_cauldron": "Pairòla d'aiga",
  "block.minecraft.waxed_chiseled_copper": "Coire escultat encerat",
  "block.minecraft.waxed_copper_bars": "Waxed Copper Bars",
  "block.minecraft.waxed_copper_block": "Blòc de coire encerat",
  "block.minecraft.waxed_copper_bulb": "Ampola en coire encerada",
  "block.minecraft.waxed_copper_chain": "Waxed Copper Chain",
  "block.minecraft.waxed_copper_chest": "Waxed Copper Chest",
  "block.minecraft.waxed_copper_door": "Pòrta en coire encerada",
  "block.minecraft.waxed_copper_golem_statue": "Waxed Copper Golem Statue",
  "block.minecraft.waxed_copper_grate": "Grasilha en coire encerada",
  "block.minecraft.waxed_copper_lantern": "Waxed Copper Lantern",
  "block.minecraft.waxed_copper_trapdoor": "Trapa en coire encerada",
  "block.minecraft.waxed_cut_copper": "Coire talhat encerat",
  "block.minecraft.waxed_cut_copper_slab": "Lausa en coire talhada encerada",
  "block.minecraft.waxed_cut_copper_stairs": "Escalièrs en coire talhat encerat",
  "block.minecraft.waxed_exposed_chiseled_copper": "Coire escultat expausat encerat",
  "block.minecraft.waxed_exposed_copper": "Coire expausat encerat",
  "block.minecraft.waxed_exposed_copper_bars": "Waxed Exposed Copper Bars",
  "block.minecraft.waxed_exposed_copper_bulb": "Ampola en coire expausada encerada",
  "block.minecraft.waxed_exposed_copper_chain": "Waxed Exposed Copper Chain",
  "block.minecraft.waxed_exposed_copper_chest": "Waxed Exposed Copper Chest",
  "block.minecraft.waxed_exposed_copper_door": "Pòrta en coire expausada encerada",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Waxed Exposed Copper Golem Statue",
  "block.minecraft.waxed_exposed_copper_grate": "Grasilha en coire expausada encerada",
  "block.minecraft.waxed_exposed_copper_lantern": "Waxed Exposed Copper Lantern",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trapa en coire expausada encerada",
  "block.minecraft.waxed_exposed_cut_copper": "Coire talhat expausat encerat",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Lausa en coire talhada expausada encerada",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escalièrs en coire talhat expausat encerat",
  "block.minecraft.waxed_exposed_lightning_rod": "Waxed Exposed Lightning Rod",
  "block.minecraft.waxed_lightning_rod": "Waxed Lightning Rod",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Coire escultat oxidat encerat",
  "block.minecraft.waxed_oxidized_copper": "Coire oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_bars": "Waxed Oxidized Copper Bars",
  "block.minecraft.waxed_oxidized_copper_bulb": "Ampola en coire oxidada encerada",
  "block.minecraft.waxed_oxidized_copper_chain": "Waxed Oxidized Copper Chain",
  "block.minecraft.waxed_oxidized_copper_chest": "Waxed Oxidized Copper Chest",
  "block.minecraft.waxed_oxidized_copper_door": "Pòrta en coire oxidada encerada",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Waxed Oxidized Copper Golem Statue",
  "block.minecraft.waxed_oxidized_copper_grate": "Grasilha en coire oxidada encerada",
  "block.minecraft.waxed_oxidized_copper_lantern": "Waxed Oxidized Copper Lantern",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trapa en coire oxidada encerada",
  "block.minecraft.waxed_oxidized_cut_copper": "Coire talhat oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Lausa en coire talhada oxidada encerada",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escalièrs en coire talhat oxidat encerat",
  "block.minecraft.waxed_oxidized_lightning_rod": "Waxed Oxidized Lightning Rod",
  "block.minecraft.waxed_weathered_chiseled_copper": "Coire escultat corroït encerat",
  "block.minecraft.waxed_weathered_copper": "Coire corroït encerat",
  "block.minecraft.waxed_weathered_copper_bars": "Waxed Weathered Copper Bars",
  "block.minecraft.waxed_weathered_copper_bulb": "Ampola en coire corroïda encerada",
  "block.minecraft.waxed_weathered_copper_chain": "Waxed Weathered Copper Chain",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Pòrta en coire corroïda encerada",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Waxed Weathered Copper Golem Statue",
  "block.minecraft.waxed_weathered_copper_grate": "Grasilha en coire corroïda encerada",
  "block.minecraft.waxed_weathered_copper_lantern": "Waxed Weathered Copper Lantern",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trapa en coire corroïda encerada",
  "block.minecraft.waxed_weathered_cut_copper": "Coire talhat corroït encerat",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Lausa en coire talhada corroïda encerada",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escalièrs en coire talhat corroït encerat",
  "block.minecraft.waxed_weathered_lightning_rod": "Waxed Weathered Lightning Rod",
  "block.minecraft.weathered_chiseled_copper": "Coire escultat corroït",
  "block.minecraft.weathered_copper": "Coire corroït",
  "block.minecraft.weathered_copper_bars": "Weathered Copper Bars",
  "block.minecraft.weathered_copper_bulb": "Ampola en coire corroïda",
  "block.minecraft.weathered_copper_chain": "Cadena de Coire Usada",
  "block.minecraft.weathered_copper_chest": "Weathered Copper Chest",
  "block.minecraft.weathered_copper_door": "Pòrta en coire corroïda",
  "block.minecraft.weathered_copper_golem_statue": "Estatua de Golèm de Coire Usada",
  "block.minecraft.weathered_copper_grate": "Grasilha en coire corroïda",
  "block.minecraft.weathered_copper_lantern": "Weathered Copper Lantern",
  "block.minecraft.weathered_copper_trapdoor": "Trapa en coire corroïda",
  "block.minecraft.weathered_cut_copper": "Coire talhat corroït",
  "block.minecraft.weathered_cut_copper_slab": "Lausa en coire talhada corroïda",
  "block.minecraft.weathered_cut_copper_stairs": "Escalièrs en coire talhat corroït",
  "block.minecraft.weathered_lightning_rod": "Weathered Lightning Rod",
  "block.minecraft.weeping_vines": "Lianas plorosas",
  "block.minecraft.weeping_vines_plant": "Planta de lianas plorosas",
  "block.minecraft.wet_sponge": "Esponja trempada",
  "block.minecraft.wheat": "Culturas de blat",
  "block.minecraft.white_banner": "Bandièra blanca",
  "block.minecraft.white_bed": "Lièch blanc",
  "block.minecraft.white_candle": "Candèla blanca",
  "block.minecraft.white_candle_cake": "Pastís amb candèla blanca",
  "block.minecraft.white_carpet": "Moqueta blanca",
  "block.minecraft.white_concrete": "Beton blanc",
  "block.minecraft.white_concrete_powder": "Polsa de beton blanca",
  "block.minecraft.white_glazed_terracotta": "Tèrra cuècha esmautada blanca",
  "block.minecraft.white_shulker_box": "Bóstia de Shulker blanca",
  "block.minecraft.white_stained_glass": "Veire blanc",
  "block.minecraft.white_stained_glass_pane": "Panèu de veire blanc",
  "block.minecraft.white_terracotta": "Tèrra cuècha blanca",
  "block.minecraft.white_tulip": "Tulipa blanca",
  "block.minecraft.white_wool": "Lana blanca",
  "block.minecraft.wildflowers": "Flors salvatjas",
  "block.minecraft.wither_rose": "Ròsa de wither",
  "block.minecraft.wither_skeleton_skull": "Cran d'esqueleta wither",
  "block.minecraft.wither_skeleton_wall_skull": "Cran d'esqueleta wither murau",
  "block.minecraft.yellow_banner": "Bandièra jauna",
  "block.minecraft.yellow_bed": "Lièch jaune",
  "block.minecraft.yellow_candle": "Candèla jauna",
  "block.minecraft.yellow_candle_cake": "Pastís amb candèla jauna",
  "block.minecraft.yellow_carpet": "Moqueta jauna",
  "block.minecraft.yellow_concrete": "Beton jaune",
  "block.minecraft.yellow_concrete_powder": "Polsa de beton jauna",
  "block.minecraft.yellow_glazed_terracotta": "Tèrra cuècha esmautada jauna",
  "block.minecraft.yellow_shulker_box": "Bóstia de Shulker jauna",
  "block.minecraft.yellow_stained_glass": "Veire jaune",
  "block.minecraft.yellow_stained_glass_pane": "Panèu de veire jaune",
  "block.minecraft.yellow_terracotta": "Tèrra cuècha jauna",
  "block.minecraft.yellow_wool": "Lana jauna",
  "block.minecraft.zombie_head": "Cap de zòmbi",
  "block.minecraft.zombie_wall_head": "Cap de zòmbi murau",
  "item.minecraft.acacia_boat": "Batèu en cacièr",
  "item.minecraft.acacia_chest_boat": "Batèu en cacièr amb còfre",
  "item.minecraft.allay_spawn_egg": "Uòu d'aparicion d'allay",
  "item.minecraft.amethyst_shard": "Fragment d'ametista",
  "item.minecraft.angler_pottery_shard": "Tèst de terralha de pescaire",
  "item.minecraft.angler_pottery_sherd": "Tèst de terralha de pescaire",
  "item.minecraft.apple": "Poma",
  "item.minecraft.archer_pottery_shard": "Tèst de terralha d'arquièr",
  "item.minecraft.archer_pottery_sherd": "Tèst de terralha d'arquièr",
  "item.minecraft.armadillo_scute": "Placa de tató",
  "item.minecraft.armadillo_spawn_egg": "Uòu d'aparicion de tató",
  "item.minecraft.armor_stand": "Pòrta-armadura",
  "item.minecraft.arms_up_pottery_shard": "Tèst de terralha de braçes alçats",
  "item.minecraft.arms_up_pottery_sherd": "Tèst de terralha de braçes alçats",
  "item.minecraft.arrow": "Sageta",
  "item.minecraft.axolotl_bucket": "Axolòtl dins un ferrat",
  "item.minecraft.axolotl_spawn_egg": "Uòu d'aparcion d'axolòtl",
  "item.minecraft.baked_potato": "Patana cuècha",
  "item.minecraft.bamboo_chest_raft": "Radèu en bambó amb còfre",
  "item.minecraft.bamboo_raft": "Radèu en bambó",
  "item.minecraft.bat_spawn_egg": "Uòu d'aparicion de ratapenada",
  "item.minecraft.bee_spawn_egg": "Uòu d'aparicion d'abelha",
  "item.minecraft.beef": "Buòu crus",
  "item.minecraft.beetroot": "Bledarava",
  "item.minecraft.beetroot_seeds": "Granas de bledarava",
  "item.minecraft.beetroot_soup": "Sopa de bledarava",
  "item.minecraft.birch_boat": "Batèu en bèç",
  "item.minecraft.birch_chest_boat": "Batèu en bèç amb còfre",
  "item.minecraft.black_bundle": "Sac negre",
  "item.minecraft.black_dye": "Tencha negra",
  "item.minecraft.black_harness": "Arnesc negre",
  "item.minecraft.blade_pottery_shard": "Tèst de terralha de lama",
  "item.minecraft.blade_pottery_sherd": "Tèst de terralha de lama",
  "item.minecraft.blaze_powder": "Polsa de blaze",
  "item.minecraft.blaze_rod": "Baston de blaze",
  "item.minecraft.blaze_spawn_egg": "Uòu d'aparicion de blaze",
  "item.minecraft.blue_bundle": "Sac blau",
  "item.minecraft.blue_dye": "Tencha blava",
  "item.minecraft.blue_egg": "Uòu blau",
  "item.minecraft.blue_harness": "Arnesc blau",
  "item.minecraft.bogged_spawn_egg": "Uòu d'aparicion d'enfagat",
  "item.minecraft.bolt_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Ondradura dels bolons",
  "item.minecraft.bone": "Òs",
  "item.minecraft.bone_meal": "Polsa d'òs",
  "item.minecraft.book": "Libre",
  "item.minecraft.bordure_indented_banner_pattern": "Motiu de bordadura endentada per bandièra",
  "item.minecraft.bow": "Arc",
  "item.minecraft.bowl": "Bòl",
  "item.minecraft.bread": "Pan",
  "item.minecraft.breeze_rod": "Baston de Ventolet",
  "item.minecraft.breeze_spawn_egg": "Uòu d'aparicion de ventolet",
  "item.minecraft.brewer_pottery_shard": "Tèst de terralha d'alquimista",
  "item.minecraft.brewer_pottery_sherd": "Tèst de terralha d'alquimista",
  "item.minecraft.brewing_stand": "Alambic",
  "item.minecraft.brick": "Brica",
  "item.minecraft.brown_bundle": "Sac brun",
  "item.minecraft.brown_dye": "Tencha bruna",
  "item.minecraft.brown_egg": "Uòu brun",
  "item.minecraft.brown_harness": "Arnesc brun",
  "item.minecraft.brush": "Bròssa",
  "item.minecraft.bucket": "Ferrat",
  "item.minecraft.bundle": "Sac",
  "item.minecraft.bundle.empty": "Vuèg",
  "item.minecraft.bundle.empty.description": "Pòt conténer una pila de mai d'un objècte",
  "item.minecraft.bundle.full": "Plen",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Tèst de terralha de fòc",
  "item.minecraft.burn_pottery_sherd": "Tèst de terralha de fòc",
  "item.minecraft.camel_husk_spawn_egg": "Camel Husk Spawn Egg",
  "item.minecraft.camel_spawn_egg": "Uòu d'aparicion de dromadari",
  "item.minecraft.carrot": "Pastenaga",
  "item.minecraft.carrot_on_a_stick": "Pastenaga sus un baston",
  "item.minecraft.cat_spawn_egg": "Uòu d'aparicion de cat",
  "item.minecraft.cauldron": "Pairòla",
  "item.minecraft.cave_spider_spawn_egg": "Uòu d'aparicion d'aranha de bauma",
  "item.minecraft.chainmail_boots": "Bòtas en còta de malhas",
  "item.minecraft.chainmail_chestplate": "Plastron en còta de malhas",
  "item.minecraft.chainmail_helmet": "Casco en còta de malhas",
  "item.minecraft.chainmail_leggings": "Cambièras en còta de malhas",
  "item.minecraft.charcoal": "Carbon de fusta",
  "item.minecraft.cherry_boat": "Batèu en cerièis",
  "item.minecraft.cherry_chest_boat": "Batèu amb còfre en cerièis",
  "item.minecraft.chest_minecart": "Vagonet amb còfre",
  "item.minecraft.chicken": "Polastre crus",
  "item.minecraft.chicken_spawn_egg": "Uòu d'aparicion de polastre",
  "item.minecraft.chorus_fruit": "Fruch de còrus",
  "item.minecraft.clay_ball": "Bola d'argila",
  "item.minecraft.clock": "Relòtge",
  "item.minecraft.coal": "Carbon",
  "item.minecraft.coast_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Ondradura dels litorales",
  "item.minecraft.cocoa_beans": "Cacau",
  "item.minecraft.cod": "Merluça crusa",
  "item.minecraft.cod_bucket": "Merluça dins un ferrat",
  "item.minecraft.cod_spawn_egg": "Uòu d'aparicion de merluça",
  "item.minecraft.command_block_minecart": "Vagonet amb blòc de comandas",
  "item.minecraft.compass": "Bossòla",
  "item.minecraft.cooked_beef": "Bistèc",
  "item.minecraft.cooked_chicken": "Polastre cuèch",
  "item.minecraft.cooked_cod": "Merluça cuècha",
  "item.minecraft.cooked_mutton": "Moton cuèch",
  "item.minecraft.cooked_porkchop": "Costeleta de pòrc cuèch",
  "item.minecraft.cooked_rabbit": "Conilh cuèch",
  "item.minecraft.cooked_salmon": "Saumon cuèch",
  "item.minecraft.cookie": "Coqueta",
  "item.minecraft.copper_axe": "Copper Axe",
  "item.minecraft.copper_boots": "Copper Boots",
  "item.minecraft.copper_chestplate": "Copper Chestplate",
  "item.minecraft.copper_golem_spawn_egg": "Copper Golem Spawn Egg",
  "item.minecraft.copper_helmet": "Copper Helmet",
  "item.minecraft.copper_hoe": "Copper Hoe",
  "item.minecraft.copper_horse_armor": "Copper Horse Armor",
  "item.minecraft.copper_ingot": "Lingòt de coire",
  "item.minecraft.copper_leggings": "Copper Leggings",
  "item.minecraft.copper_nautilus_armor": "Copper Nautilus Armor",
  "item.minecraft.copper_nugget": "Copper Nugget",
  "item.minecraft.copper_pickaxe": "Copper Pickaxe",
  "item.minecraft.copper_shovel": "Copper Shovel",
  "item.minecraft.copper_spear": "Copper Spear",
  "item.minecraft.copper_sword": "Copper Sword",
  "item.minecraft.cow_spawn_egg": "Uòu d'aparicion de vaca",
  "item.minecraft.creaking_spawn_egg": "Uòu d'aparicion de cruisseire",
  "item.minecraft.creeper_banner_pattern": "Motiu de bandièra",
  "item.minecraft.creeper_banner_pattern.desc": "Fàcia de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Motiu de fàcia de creeper per bandièra",
  "item.minecraft.creeper_spawn_egg": "Uòu d'aparicion de creeper",
  "item.minecraft.crossbow": "Balèsta",
  "item.minecraft.crossbow.projectile": "Projectil :",
  "item.minecraft.crossbow.projectile.multiple": "Projectil : %s × %s",
  "item.minecraft.crossbow.projectile.single": "Projectil : %s",
  "item.minecraft.cyan_bundle": "Sac cian",
  "item.minecraft.cyan_dye": "Tencha cian",
  "item.minecraft.cyan_harness": "Arnesc cian",
  "item.minecraft.danger_pottery_shard": "Tèst de terralha de perilh",
  "item.minecraft.danger_pottery_sherd": "Tèst de terralha de perilh",
  "item.minecraft.dark_oak_boat": "Batèu en euse escur",
  "item.minecraft.dark_oak_chest_boat": "Batèu en euse escur amb còfre",
  "item.minecraft.debug_stick": "Baston de desbogatge",
  "item.minecraft.debug_stick.empty": "%s n'a pas de proprietat",
  "item.minecraft.debug_stick.select": "\"%s\" seleccionat (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" a %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Pigassa en diamant",
  "item.minecraft.diamond_boots": "Bòtas en diamant",
  "item.minecraft.diamond_chestplate": "Plastron en diamant",
  "item.minecraft.diamond_helmet": "Casco en diamant",
  "item.minecraft.diamond_hoe": "Bigòs en diamant",
  "item.minecraft.diamond_horse_armor": "Armadura en diamant per cavau",
  "item.minecraft.diamond_leggings": "Cambièras en diamant",
  "item.minecraft.diamond_nautilus_armor": "Diamond Nautilus Armor",
  "item.minecraft.diamond_pickaxe": "Trenca en diamant",
  "item.minecraft.diamond_shovel": "Pala en diamant",
  "item.minecraft.diamond_spear": "Diamond Spear",
  "item.minecraft.diamond_sword": "Espasa en diamant",
  "item.minecraft.disc_fragment_5": "Fragment de disc",
  "item.minecraft.disc_fragment_5.desc": "Disc de musica - 5",
  "item.minecraft.dolphin_spawn_egg": "Uòu d'aparicion de daufin",
  "item.minecraft.donkey_spawn_egg": "Uòu d'aparicion d'ase",
  "item.minecraft.dragon_breath": "Buf de dragon",
  "item.minecraft.dried_kelp": "Augas secadas",
  "item.minecraft.drowned_spawn_egg": "Uòu d'aparicion de negat",
  "item.minecraft.dune_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Ondradura de las dunas",
  "item.minecraft.echo_shard": "Tròç de resson",
  "item.minecraft.egg": "Uòu",
  "item.minecraft.elder_guardian_spawn_egg": "Uòu d'aparicion de grand gardian",
  "item.minecraft.elytra": "Elitres",
  "item.minecraft.emerald": "Esmerauda",
  "item.minecraft.enchanted_book": "Libre encantat",
  "item.minecraft.enchanted_golden_apple": "Poma daurada encantada",
  "item.minecraft.end_crystal": "Cristau de l'End",
  "item.minecraft.ender_dragon_spawn_egg": "Uòu d'aparicion de Dragon d'Ender",
  "item.minecraft.ender_eye": "Uèlh d'Ender",
  "item.minecraft.ender_pearl": "Pèrla d'ender",
  "item.minecraft.enderman_spawn_egg": "Uòu d'aparicion d'enderòme",
  "item.minecraft.endermite_spawn_egg": "Uòu d'aparicion d'enderarna",
  "item.minecraft.evoker_spawn_egg": "Uòu d'aparicion d'evocator",
  "item.minecraft.experience_bottle": "Fiòla d'experiéncia",
  "item.minecraft.explorer_pottery_shard": "Tèst de terralha de descobèrta",
  "item.minecraft.explorer_pottery_sherd": "Tèst de terralha de descobèrta",
  "item.minecraft.eye_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Ondradura del uèlh",
  "item.minecraft.feather": "Pluma",
  "item.minecraft.fermented_spider_eye": "Uèlh d'aranha fermentat",
  "item.minecraft.field_masoned_banner_pattern": "Motiu de camp maçonat per bandièra",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Pelòta de fuòc",
  "item.minecraft.firework_rocket": "Fuòc d'Artifici",
  "item.minecraft.firework_rocket.flight": "Temps de vòl:",
  "item.minecraft.firework_rocket.multiple_stars": "%s × %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estela de Fuòc d'Artifici",
  "item.minecraft.firework_star.black": "Negre",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Brun",
  "item.minecraft.firework_star.custom_color": "Personalizat",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Fondut en",
  "item.minecraft.firework_star.flicker": "Belugas",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Verde",
  "item.minecraft.firework_star.light_blue": "Blau clar",
  "item.minecraft.firework_star.light_gray": "Gris clar",
  "item.minecraft.firework_star.lime": "Lima",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Irange",
  "item.minecraft.firework_star.pink": "Ròse",
  "item.minecraft.firework_star.purple": "Violet",
  "item.minecraft.firework_star.red": "Roge",
  "item.minecraft.firework_star.shape": "Fòrma Desconeguda",
  "item.minecraft.firework_star.shape.burst": "Espetar",
  "item.minecraft.firework_star.shape.creeper": "En fòrma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Bola granda",
  "item.minecraft.firework_star.shape.small_ball": "Bola pichona",
  "item.minecraft.firework_star.shape.star": "En fòrma d'estela",
  "item.minecraft.firework_star.trail": "Traïnadas",
  "item.minecraft.firework_star.white": "Blanc",
  "item.minecraft.firework_star.yellow": "Jaune",
  "item.minecraft.fishing_rod": "Cana de pesca",
  "item.minecraft.flint": "Frejau",
  "item.minecraft.flint_and_steel": "Batifuòc",
  "item.minecraft.flow_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Ondradura dels revolums",
  "item.minecraft.flow_banner_pattern": "Motiu de bandièra",
  "item.minecraft.flow_banner_pattern.desc": "Revolum",
  "item.minecraft.flow_banner_pattern.new": "Motiu de revolum per bandièra",
  "item.minecraft.flow_pottery_sherd": "Tèst de terralha de revolum",
  "item.minecraft.flower_banner_pattern": "Motiu de bandièra",
  "item.minecraft.flower_banner_pattern.desc": "Flor",
  "item.minecraft.flower_banner_pattern.new": "Motiu de flor per bandièra",
  "item.minecraft.flower_pot": "Topin",
  "item.minecraft.fox_spawn_egg": "Uòu d'aparicion de rainard",
  "item.minecraft.friend_pottery_shard": "Tèst de terralha d'amic",
  "item.minecraft.friend_pottery_sherd": "Tèst de terralha d'amic",
  "item.minecraft.frog_spawn_egg": "Uòu d'aparicion de granolha",
  "item.minecraft.furnace_minecart": "Vagonet amb forn",
  "item.minecraft.ghast_spawn_egg": "Uòu d'aparicion de ghast",
  "item.minecraft.ghast_tear": "Lagrema de ghast",
  "item.minecraft.glass_bottle": "Fiòla",
  "item.minecraft.glistering_melon_slice": "Talhon de pastèca daurada",
  "item.minecraft.globe_banner_pattern": "Motiu de bandièra",
  "item.minecraft.globe_banner_pattern.desc": "Glòbe",
  "item.minecraft.globe_banner_pattern.new": "Motiu de glòbe per bandièra",
  "item.minecraft.glow_berries": "Bagas lusentas",
  "item.minecraft.glow_ink_sac": "Sac de tencha lusent",
  "item.minecraft.glow_item_frame": "Quadre lusent",
  "item.minecraft.glow_squid_spawn_egg": "Uòu d'aparicion de tautena lusenta",
  "item.minecraft.glowstone_dust": "Polsa de pèira luminosa",
  "item.minecraft.goat_horn": "Còrn de cabra",
  "item.minecraft.goat_spawn_egg": "Uòu d'aparicion de cabra",
  "item.minecraft.gold_ingot": "Lingòt d'aur",
  "item.minecraft.gold_nugget": "Pepita d'aur",
  "item.minecraft.golden_apple": "Poma daurada",
  "item.minecraft.golden_axe": "Pigassa en aur",
  "item.minecraft.golden_boots": "Bòtas en aur",
  "item.minecraft.golden_carrot": "Pastenaga daurada",
  "item.minecraft.golden_chestplate": "Plastron en aur",
  "item.minecraft.golden_helmet": "Casco en aur",
  "item.minecraft.golden_hoe": "Bigòs en aur",
  "item.minecraft.golden_horse_armor": "Armadura en aur per cavau",
  "item.minecraft.golden_leggings": "Cambièras en aur",
  "item.minecraft.golden_nautilus_armor": "Golden Nautilus Armor",
  "item.minecraft.golden_pickaxe": "Trenca en aur",
  "item.minecraft.golden_shovel": "Pala en aur",
  "item.minecraft.golden_spear": "Golden Spear",
  "item.minecraft.golden_sword": "Espasa en aur",
  "item.minecraft.gray_bundle": "Sac gris",
  "item.minecraft.gray_dye": "Tencha gris",
  "item.minecraft.gray_harness": "Arnesc gris",
  "item.minecraft.green_bundle": "Sac verd",
  "item.minecraft.green_dye": "Tencha verda",
  "item.minecraft.green_harness": "Arnes verd",
  "item.minecraft.guardian_spawn_egg": "Uòu d'aparicion de gardian",
  "item.minecraft.gunpowder": "Pouvera",
  "item.minecraft.guster_banner_pattern": "Motiu de bandièra",
  "item.minecraft.guster_banner_pattern.desc": "Ventorià",
  "item.minecraft.guster_banner_pattern.new": "Motiu de ventorià per bandièra",
  "item.minecraft.guster_pottery_sherd": "Tèst de terralha de ventòria",
  "item.minecraft.happy_ghast_spawn_egg": "Uòu d'aparicion de ghast urós",
  "item.minecraft.harness": "Arnesc",
  "item.minecraft.heart_of_the_sea": "Còr de la mar",
  "item.minecraft.heart_pottery_shard": "Tèst de terralha de còr",
  "item.minecraft.heart_pottery_sherd": "Tèst de terralha de còr",
  "item.minecraft.heartbreak_pottery_shard": "Tèst de terralha de còr trencat",
  "item.minecraft.heartbreak_pottery_sherd": "Tèst de terralha de còr trencat",
  "item.minecraft.hoglin_spawn_egg": "Uòu d'aparicion de hoglin",
  "item.minecraft.honey_bottle": "Fiòla de mèu",
  "item.minecraft.honeycomb": "Bresca",
  "item.minecraft.hopper_minecart": "Vagonet amb embut",
  "item.minecraft.horse_spawn_egg": "Uòu d'aparicion de cavau",
  "item.minecraft.host_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.host_armor_trim_smithing_template.new": "Ondradura dels òstes",
  "item.minecraft.howl_pottery_shard": "Tèst de terralha de lop",
  "item.minecraft.howl_pottery_sherd": "Tèst de terralha de lop",
  "item.minecraft.husk_spawn_egg": "Uòu d'aparicion de zòmbi momificat",
  "item.minecraft.ink_sac": "Sac de tencha",
  "item.minecraft.iron_axe": "Pigassa en fèrre",
  "item.minecraft.iron_boots": "Bòtas en fèrre",
  "item.minecraft.iron_chestplate": "Plastron en fèrre",
  "item.minecraft.iron_golem_spawn_egg": "Uòu d'aparicion de golem de fèrre",
  "item.minecraft.iron_helmet": "Casco en fèrre",
  "item.minecraft.iron_hoe": "Bigòs en fèrre",
  "item.minecraft.iron_horse_armor": "Armadura en fèrre per cavau",
  "item.minecraft.iron_ingot": "Lingòt de fèrre",
  "item.minecraft.iron_leggings": "Cambièras en fèrre",
  "item.minecraft.iron_nautilus_armor": "Iron Nautilus Armor",
  "item.minecraft.iron_nugget": "Pepita de fèrre",
  "item.minecraft.iron_pickaxe": "Trenca en fèrre",
  "item.minecraft.iron_shovel": "Pala en fèrre",
  "item.minecraft.iron_spear": "Iron Spear",
  "item.minecraft.iron_sword": "Espasa en fèrre",
  "item.minecraft.item_frame": "Quadre",
  "item.minecraft.jungle_boat": "Batèu de jungla",
  "item.minecraft.jungle_chest_boat": "Batèu de jungla amb còfre",
  "item.minecraft.knowledge_book": "Libre de las coneissénças",
  "item.minecraft.lapis_lazuli": "Lapislazuli",
  "item.minecraft.lava_bucket": "Ferrat de lava",
  "item.minecraft.lead": "Laç",
  "item.minecraft.leather": "Cuèr",
  "item.minecraft.leather_boots": "Bòtas en cuèr",
  "item.minecraft.leather_chestplate": "Tunica en cuèr",
  "item.minecraft.leather_helmet": "Capèu en cuèr",
  "item.minecraft.leather_horse_armor": "Armadura en cuèr per cavau",
  "item.minecraft.leather_leggings": "Pantalons en cuèr",
  "item.minecraft.light_blue_bundle": "Sac blau clar",
  "item.minecraft.light_blue_dye": "Tencha blau clar",
  "item.minecraft.light_blue_harness": "Arnesc blau clar",
  "item.minecraft.light_gray_bundle": "Sac gris clar",
  "item.minecraft.light_gray_dye": "Tencha gris clar",
  "item.minecraft.light_gray_harness": "Arnesc gris clar",
  "item.minecraft.lime_bundle": "Sac lima",
  "item.minecraft.lime_dye": "Tencha lima",
  "item.minecraft.lime_harness": "Arnesc verd clar",
  "item.minecraft.lingering_potion": "Pocion persistenta",
  "item.minecraft.lingering_potion.effect.awkward": "Pocion estranha persistenta",
  "item.minecraft.lingering_potion.effect.empty": "Pocion de persisténcia non fabricabla",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Pocion de resisténcia au fuòc persistenta",
  "item.minecraft.lingering_potion.effect.harming": "Pocion de degalh persistenta",
  "item.minecraft.lingering_potion.effect.healing": "Pocion de suènh persistenta",
  "item.minecraft.lingering_potion.effect.infested": "Pocion persistenta d'enfeciment",
  "item.minecraft.lingering_potion.effect.invisibility": "Pocion d'invisibilitat persistenta",
  "item.minecraft.lingering_potion.effect.leaping": "Pocion de saut persistenta",
  "item.minecraft.lingering_potion.effect.levitation": "Pocion de levitacion persistenta",
  "item.minecraft.lingering_potion.effect.luck": "Pocion d'astre persistenta",
  "item.minecraft.lingering_potion.effect.mundane": "Pocion banala persistenta",
  "item.minecraft.lingering_potion.effect.night_vision": "Pocion de vision nocturna persistenta",
  "item.minecraft.lingering_potion.effect.oozing": "Pocion persistenta de viscositat",
  "item.minecraft.lingering_potion.effect.poison": "Pocion de poison persistenta",
  "item.minecraft.lingering_potion.effect.regeneration": "Pocion de regeneracion persistenta",
  "item.minecraft.lingering_potion.effect.slow_falling": "Pocion de casuda lenta persistenta",
  "item.minecraft.lingering_potion.effect.slowness": "Pocion de lentor persistenta",
  "item.minecraft.lingering_potion.effect.strength": "Pocion de fòrça persistenta",
  "item.minecraft.lingering_potion.effect.swiftness": "Pocion de velocitat persistenta",
  "item.minecraft.lingering_potion.effect.thick": "Pocion espessa persistenta",
  "item.minecraft.lingering_potion.effect.turtle_master": "Pocion dau mèstre tartuga persistenta",
  "item.minecraft.lingering_potion.effect.water": "Fiòla d'aiga persistenta",
  "item.minecraft.lingering_potion.effect.water_breathing": "Pocion de respiracion aqüatica persistenta",
  "item.minecraft.lingering_potion.effect.weakness": "Pocion de flaquesa persistenta",
  "item.minecraft.lingering_potion.effect.weaving": "Pocion persistenta de teisseire",
  "item.minecraft.lingering_potion.effect.wind_charged": "Pocion persistenta de Buf",
  "item.minecraft.llama_spawn_egg": "Uòu d'aparicion de lama",
  "item.minecraft.lodestone_compass": "Bossòla magnetizada",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Sac magenta",
  "item.minecraft.magenta_dye": "Tencha magenta",
  "item.minecraft.magenta_harness": "Arnesc magenta",
  "item.minecraft.magma_cream": "Crèma de magma",
  "item.minecraft.magma_cube_spawn_egg": "Uòu d'aparicion de cube de magma",
  "item.minecraft.mangrove_boat": "Batèu en manglièr",
  "item.minecraft.mangrove_chest_boat": "Batèu en manglièr amb còfre",
  "item.minecraft.map": "Mapa verge",
  "item.minecraft.melon_seeds": "Granas de pastèca",
  "item.minecraft.melon_slice": "Talhon de pastèca",
  "item.minecraft.milk_bucket": "Ferrat de lach",
  "item.minecraft.minecart": "Vagonet",
  "item.minecraft.miner_pottery_shard": "Tèst de terralha de minaire",
  "item.minecraft.miner_pottery_sherd": "Tèst de terralha de minaire",
  "item.minecraft.mojang_banner_pattern": "Motiu de bandièra",
  "item.minecraft.mojang_banner_pattern.desc": "Simbòle",
  "item.minecraft.mojang_banner_pattern.new": "Motiu d'emblèma per bandièra",
  "item.minecraft.mooshroom_spawn_egg": "Uòu d'aparicion de vacamparòu",
  "item.minecraft.mourner_pottery_shard": "Tèst de terralha de ploraire",
  "item.minecraft.mourner_pottery_sherd": "Tèst de terralha de ploraire",
  "item.minecraft.mule_spawn_egg": "Uòu d'aparicion de mula",
  "item.minecraft.mushroom_stew": "Sopa de camparòu",
  "item.minecraft.music_disc_11": "Disc de musica",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disc de musica",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disc de Musica",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disc de musica",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disc de musica",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disc de musica",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disc",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disc",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Boita a musica)",
  "item.minecraft.music_disc_far": "Disc de musica",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disc de musica",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disc de musica",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disc de musica",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disc de musica",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disc de musica",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disc",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disc de musica",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disc de musica",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disc de musica",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disc de musica",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disc de musica",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disc de musica",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Moton crus",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Clòsca de nautile",
  "item.minecraft.nautilus_spawn_egg": "Nautilus Spawn Egg",
  "item.minecraft.nether_brick": "Brica dau Nether",
  "item.minecraft.nether_star": "Estela dau Nether",
  "item.minecraft.nether_wart": "Verruga del Nether",
  "item.minecraft.netherite_axe": "Pigassa en netherita",
  "item.minecraft.netherite_boots": "Bòtas en netherita",
  "item.minecraft.netherite_chestplate": "Plastron en netherita",
  "item.minecraft.netherite_helmet": "Casco en netherita",
  "item.minecraft.netherite_hoe": "Bigòs en netherita",
  "item.minecraft.netherite_horse_armor": "Netherite Horse Armor",
  "item.minecraft.netherite_ingot": "Lingòt de netherita",
  "item.minecraft.netherite_leggings": "Cambièras en netherita",
  "item.minecraft.netherite_nautilus_armor": "Netherite Nautilus Armor",
  "item.minecraft.netherite_pickaxe": "Trenca en netherita",
  "item.minecraft.netherite_scrap": "Fragment de netherita",
  "item.minecraft.netherite_shovel": "Pala en netherita",
  "item.minecraft.netherite_spear": "Netherite Spear",
  "item.minecraft.netherite_sword": "Espasa en netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Modèl de fargatge",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Melhorament en netherita",
  "item.minecraft.oak_boat": "Batèu en euse",
  "item.minecraft.oak_chest_boat": "Batèu en euse amb còfre",
  "item.minecraft.ocelot_spawn_egg": "Uòu d'aparcion d'ocelòt",
  "item.minecraft.ominous_bottle": "Fiòla funèsta",
  "item.minecraft.ominous_trial_key": "Clau de las espròvas funèst",
  "item.minecraft.orange_bundle": "Sac irange",
  "item.minecraft.orange_dye": "Tencha iranja",
  "item.minecraft.orange_harness": "Arnesc irange",
  "item.minecraft.painting": "Pintura",
  "item.minecraft.pale_oak_boat": "Batèu en euse palle",
  "item.minecraft.pale_oak_chest_boat": "Batèu en euse palle amb còfre",
  "item.minecraft.panda_spawn_egg": "Uòu d'aparicion de panda",
  "item.minecraft.paper": "Papièr",
  "item.minecraft.parched_spawn_egg": "Parched Spawn Egg",
  "item.minecraft.parrot_spawn_egg": "Uòu d'aparcion de papagai",
  "item.minecraft.phantom_membrane": "Membrana de fantauma",
  "item.minecraft.phantom_spawn_egg": "Uòu d'aparicion de fantauma",
  "item.minecraft.pig_spawn_egg": "Uòu d'aparicion de pòrc",
  "item.minecraft.piglin_banner_pattern": "Motiu de bandièra",
  "item.minecraft.piglin_banner_pattern.desc": "Morre",
  "item.minecraft.piglin_banner_pattern.new": "Motiu de morre per bandièra",
  "item.minecraft.piglin_brute_spawn_egg": "Uòu d'aparicion de piglin ferotge",
  "item.minecraft.piglin_spawn_egg": "Uòu d'aparicion de piglin",
  "item.minecraft.pillager_spawn_egg": "Uòu d'aparicion de pilhard",
  "item.minecraft.pink_bundle": "Sac ròse",
  "item.minecraft.pink_dye": "Tencha ròsa",
  "item.minecraft.pink_harness": "Arnesc ròse",
  "item.minecraft.pitcher_plant": "Planta jarra",
  "item.minecraft.pitcher_pod": "Gran de planta jarra",
  "item.minecraft.plenty_pottery_shard": "Tèst de terralha de riquesa",
  "item.minecraft.plenty_pottery_sherd": "Tèst de terralha de riquesa",
  "item.minecraft.poisonous_potato": "Patana empoisonada",
  "item.minecraft.polar_bear_spawn_egg": "Uòu d'aparicion d'ors polar",
  "item.minecraft.popped_chorus_fruit": "Fruch de còrus esclatada",
  "item.minecraft.porkchop": "Costeleta de pòrc crusa",
  "item.minecraft.potato": "Patana",
  "item.minecraft.potion": "Pocion",
  "item.minecraft.potion.effect.awkward": "Pocion Estranha",
  "item.minecraft.potion.effect.empty": "Pocion non fabricabla",
  "item.minecraft.potion.effect.fire_resistance": "Pocion de resisténcia au fuòc",
  "item.minecraft.potion.effect.harming": "Pocion de degalhs",
  "item.minecraft.potion.effect.healing": "Pocion de suènh",
  "item.minecraft.potion.effect.infested": "Pocion d'enfeciment",
  "item.minecraft.potion.effect.invisibility": "Pocion d'invisibilitat",
  "item.minecraft.potion.effect.leaping": "Pocion de saut",
  "item.minecraft.potion.effect.levitation": "Pocion de levitacion",
  "item.minecraft.potion.effect.luck": "Pocion d'astre",
  "item.minecraft.potion.effect.mundane": "Pocion banala",
  "item.minecraft.potion.effect.night_vision": "Pocion de vision nocturna",
  "item.minecraft.potion.effect.oozing": "Pocion de viscositat",
  "item.minecraft.potion.effect.poison": "Pocion de poison",
  "item.minecraft.potion.effect.regeneration": "Pocion de regeneracion",
  "item.minecraft.potion.effect.slow_falling": "Pocion de casuda lenta",
  "item.minecraft.potion.effect.slowness": "Pocion de lentor",
  "item.minecraft.potion.effect.strength": "Pocion de fòrça",
  "item.minecraft.potion.effect.swiftness": "Pocion de velocitat",
  "item.minecraft.potion.effect.thick": "Pocion Espesa",
  "item.minecraft.potion.effect.turtle_master": "Pocion dau mèstre tartuga",
  "item.minecraft.potion.effect.water": "Fiòla d'aiga",
  "item.minecraft.potion.effect.water_breathing": "Pocion de respiracion aqüatica",
  "item.minecraft.potion.effect.weakness": "Pocion de flaquesa",
  "item.minecraft.potion.effect.weaving": "Pocion de teisseire",
  "item.minecraft.potion.effect.wind_charged": "Pocion de Buf",
  "item.minecraft.pottery_shard_archer": "Tèst de terralha d'arquièr",
  "item.minecraft.pottery_shard_arms_up": "Tèst de terralha de braçes alçadas",
  "item.minecraft.pottery_shard_prize": "Tèst de terralha de jòia",
  "item.minecraft.pottery_shard_skull": "Tèst de terralha de cran",
  "item.minecraft.powder_snow_bucket": "Ferrat de nèu polverosa",
  "item.minecraft.prismarine_crystals": "Cristaus de prismarina",
  "item.minecraft.prismarine_shard": "Tròç de prismarina",
  "item.minecraft.prize_pottery_shard": "Tèst de terralha de jòia",
  "item.minecraft.prize_pottery_sherd": "Tèst de terralha de jòia",
  "item.minecraft.pufferfish": "Peis glòbe",
  "item.minecraft.pufferfish_bucket": "Peis-glòbe dins un ferrat",
  "item.minecraft.pufferfish_spawn_egg": "Uòu d'aparicion de peis glòbe",
  "item.minecraft.pumpkin_pie": "Tarta de coja",
  "item.minecraft.pumpkin_seeds": "Granas de coja",
  "item.minecraft.purple_bundle": "Sac violet",
  "item.minecraft.purple_dye": "Tencha violeta",
  "item.minecraft.purple_harness": "Arnesc violet",
  "item.minecraft.quartz": "Qüars dau Nether",
  "item.minecraft.rabbit": "Conilh crus",
  "item.minecraft.rabbit_foot": "Pauta de conilh",
  "item.minecraft.rabbit_hide": "Pèu de conilh",
  "item.minecraft.rabbit_spawn_egg": "Uòu d'aparicion de conilh",
  "item.minecraft.rabbit_stew": "Fricòt de conilh",
  "item.minecraft.raiser_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Ondradura dels elevaires",
  "item.minecraft.ravager_spawn_egg": "Uòu d'aparicion de devastator",
  "item.minecraft.raw_copper": "Coire brut",
  "item.minecraft.raw_gold": "Aur brut",
  "item.minecraft.raw_iron": "Fèrre brut",
  "item.minecraft.recovery_compass": "Bossòla de recuperacion",
  "item.minecraft.red_bundle": "Sac roge",
  "item.minecraft.red_dye": "Tencha roja",
  "item.minecraft.red_harness": "Arnesc roge",
  "item.minecraft.redstone": "Polsa de redstone",
  "item.minecraft.resin_brick": "Brica de resina",
  "item.minecraft.resin_clump": "Amàs de resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ondradura de las còstelas",
  "item.minecraft.rotten_flesh": "Carn poirida",
  "item.minecraft.saddle": "Sèla",
  "item.minecraft.salmon": "Saumon crus",
  "item.minecraft.salmon_bucket": "Saumon dins un ferrat",
  "item.minecraft.salmon_spawn_egg": "Uòu d'aparcion de saumon",
  "item.minecraft.scrape_pottery_sherd": "Tèst de terralha de destral",
  "item.minecraft.scute": "Placa",
  "item.minecraft.sentry_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Ondradura de las sentinèlas",
  "item.minecraft.shaper_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Ondradura dels modelaires",
  "item.minecraft.sheaf_pottery_shard": "Tèst de terralha de bòta de blat",
  "item.minecraft.sheaf_pottery_sherd": "Tèst de terralha de bòta de blat",
  "item.minecraft.shears": "Cisalhas",
  "item.minecraft.sheep_spawn_egg": "Uòu d'aparicion de moton",
  "item.minecraft.shelter_pottery_shard": "Tèst de terralha d'abric",
  "item.minecraft.shelter_pottery_sherd": "Tèst de terralha d'abric",
  "item.minecraft.shield": "Bloquièr",
  "item.minecraft.shield.black": "Bloquièr negre",
  "item.minecraft.shield.blue": "Bloquièr blau",
  "item.minecraft.shield.brown": "Bloquièr brun",
  "item.minecraft.shield.cyan": "Bloquièr cian",
  "item.minecraft.shield.gray": "Bloquièr gris",
  "item.minecraft.shield.green": "Bloquièr verd",
  "item.minecraft.shield.light_blue": "Bloquièr blau clar",
  "item.minecraft.shield.light_gray": "Bloquièr gris clar",
  "item.minecraft.shield.lime": "Bloquièr lima",
  "item.minecraft.shield.magenta": "Bloquièr magenta",
  "item.minecraft.shield.orange": "Bloquièr irange",
  "item.minecraft.shield.pink": "Bloquièr ròse",
  "item.minecraft.shield.purple": "Bloquièr violet",
  "item.minecraft.shield.red": "Bloquièr roge",
  "item.minecraft.shield.white": "Bloquièr blanc",
  "item.minecraft.shield.yellow": "Bloquièr jaune",
  "item.minecraft.shulker_shell": "Clòsca de Shulker",
  "item.minecraft.shulker_spawn_egg": "Uòu d'aparicion de shulker",
  "item.minecraft.sign": "Pancarta",
  "item.minecraft.silence_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Ondradura del silenci",
  "item.minecraft.silverfish_spawn_egg": "Uòu d'aparicion de peis d'argent",
  "item.minecraft.skeleton_horse_spawn_egg": "Uòu d'aparicion de cavau esqueleta",
  "item.minecraft.skeleton_spawn_egg": "Uòu d'aparicion d'esqueleta",
  "item.minecraft.skull_banner_pattern": "Motiu de bandièra",
  "item.minecraft.skull_banner_pattern.desc": "Cran",
  "item.minecraft.skull_banner_pattern.new": "Motiu de crani per bandièra",
  "item.minecraft.skull_pottery_shard": "Tèst de terralha de cran",
  "item.minecraft.skull_pottery_sherd": "Tèst de terralha de cran",
  "item.minecraft.slime_ball": "Bola de slime",
  "item.minecraft.slime_spawn_egg": "Uòu d'aparicion de slime",
  "item.minecraft.smithing_template": "Modèl de fargatge",
  "item.minecraft.smithing_template.applies_to": "S'aplica sus :",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Apondètz un lingòt o un cristau",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Apondètz una armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingòts e cristaus",
  "item.minecraft.smithing_template.ingredients": "Ingredients :",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Apondètz un lingòt de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipament en diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Apondètz una armadura, una arma o una aisina en diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingòt de netherita",
  "item.minecraft.smithing_template.upgrade": "Melhorament : ",
  "item.minecraft.sniffer_spawn_egg": "Uòu d'aparicion de niflaire",
  "item.minecraft.snort_pottery_shard": "Tèst de terralha de niflaire",
  "item.minecraft.snort_pottery_sherd": "Tèst de terralha de niflaire",
  "item.minecraft.snout_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Ondradura dels morres",
  "item.minecraft.snow_golem_spawn_egg": "Uòu d'aparicion de golem de nèu",
  "item.minecraft.snowball": "Bola de nèu",
  "item.minecraft.spectral_arrow": "Sageta espectrala",
  "item.minecraft.spider_eye": "Uèlh d'aranha",
  "item.minecraft.spider_spawn_egg": "Uòu d'aparicion d'aranha",
  "item.minecraft.spire_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Ondradura de las torres",
  "item.minecraft.splash_potion": "Pocion getabla",
  "item.minecraft.splash_potion.effect.awkward": "Pocion Getabla Estranha",
  "item.minecraft.splash_potion.effect.empty": "Pocion getabla non fabricabla",
  "item.minecraft.splash_potion.effect.fire_resistance": "Pocion de resisténcia al fuòc getabla",
  "item.minecraft.splash_potion.effect.harming": "Pocion de degalhs getabla",
  "item.minecraft.splash_potion.effect.healing": "Pocion de suènh getabla",
  "item.minecraft.splash_potion.effect.infested": "Pocion getabla d'enfeciment",
  "item.minecraft.splash_potion.effect.invisibility": "Pocion d'invisibilitat getabla",
  "item.minecraft.splash_potion.effect.leaping": "Pocion de saut getabla",
  "item.minecraft.splash_potion.effect.levitation": "Pocion de levitacion getabla",
  "item.minecraft.splash_potion.effect.luck": "Pocion d'astre getabla",
  "item.minecraft.splash_potion.effect.mundane": "Pocion banala getabla",
  "item.minecraft.splash_potion.effect.night_vision": "Pocion de vision nocturna getabla",
  "item.minecraft.splash_potion.effect.oozing": "Pocion getabla de viscositat",
  "item.minecraft.splash_potion.effect.poison": "Pocion de poison getabla",
  "item.minecraft.splash_potion.effect.regeneration": "Pocion de regeneracion getabla",
  "item.minecraft.splash_potion.effect.slow_falling": "Pocion de casuda lenta getabla",
  "item.minecraft.splash_potion.effect.slowness": "Pocion de lentor getabla",
  "item.minecraft.splash_potion.effect.strength": "Pocion de fòrça getabla",
  "item.minecraft.splash_potion.effect.swiftness": "Pocion de velocitat getabla",
  "item.minecraft.splash_potion.effect.thick": "Pocion Getabla Espessa",
  "item.minecraft.splash_potion.effect.turtle_master": "Pocion dau mèstre tartuga getabla",
  "item.minecraft.splash_potion.effect.water": "Fiòla getabla d'aiga",
  "item.minecraft.splash_potion.effect.water_breathing": "Pocion de respiracion aqüatica getabla",
  "item.minecraft.splash_potion.effect.weakness": "Pocion de flaquesa getabla",
  "item.minecraft.splash_potion.effect.weaving": "Pocion getabla de teisseire",
  "item.minecraft.splash_potion.effect.wind_charged": "Pocion getabla de Buf",
  "item.minecraft.spruce_boat": "Batèu en avet",
  "item.minecraft.spruce_chest_boat": "Batèu en avet amb còfre",
  "item.minecraft.spyglass": "Pòrtavista",
  "item.minecraft.squid_spawn_egg": "Uòu d'aparicion de tautena",
  "item.minecraft.stick": "Baston",
  "item.minecraft.stone_axe": "Pigassa en pèira",
  "item.minecraft.stone_hoe": "Bigòs en pèira",
  "item.minecraft.stone_pickaxe": "Trenca en pèira",
  "item.minecraft.stone_shovel": "Pala en pèira",
  "item.minecraft.stone_spear": "Stone Spear",
  "item.minecraft.stone_sword": "Espasa en pèira",
  "item.minecraft.stray_spawn_egg": "Uòu d'aparicion de barrutlaire",
  "item.minecraft.strider_spawn_egg": "Uòu d'aparicion d'arpentaire",
  "item.minecraft.string": "Fiau",
  "item.minecraft.sugar": "Sucre",
  "item.minecraft.suspicious_stew": "Sopa suspècta",
  "item.minecraft.sweet_berries": "Bagas doças",
  "item.minecraft.tadpole_bucket": "Capmartèu dins un ferrat",
  "item.minecraft.tadpole_spawn_egg": "Uòu d'aparicion de capmartèu",
  "item.minecraft.tide_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Ondradura de las marèas",
  "item.minecraft.tipped_arrow": "Sageta d'efièch",
  "item.minecraft.tipped_arrow.effect.awkward": "Sageta a efièch",
  "item.minecraft.tipped_arrow.effect.empty": "Sageta especiala non fabricabla",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Sageta de resisténcia au fuòc",
  "item.minecraft.tipped_arrow.effect.harming": "Sageta de degalh",
  "item.minecraft.tipped_arrow.effect.healing": "Sageta de suènh",
  "item.minecraft.tipped_arrow.effect.infested": "Sageta d'enfeciment",
  "item.minecraft.tipped_arrow.effect.invisibility": "Sageta d'invisibilitat",
  "item.minecraft.tipped_arrow.effect.leaping": "Sageta de saut",
  "item.minecraft.tipped_arrow.effect.levitation": "Sageta de levitacion",
  "item.minecraft.tipped_arrow.effect.luck": "Sageta d'astre",
  "item.minecraft.tipped_arrow.effect.mundane": "Sageta a efièch",
  "item.minecraft.tipped_arrow.effect.night_vision": "Sageta de vision nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Sageta de viscositat",
  "item.minecraft.tipped_arrow.effect.poison": "Sageta de poison",
  "item.minecraft.tipped_arrow.effect.regeneration": "Sageta de regeneracion",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Sageta de casuda lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Sageta de lentor",
  "item.minecraft.tipped_arrow.effect.strength": "Sageta de fòrça",
  "item.minecraft.tipped_arrow.effect.swiftness": "Sageta de velocitat",
  "item.minecraft.tipped_arrow.effect.thick": "Sageta a efièch",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Sageta dau mèstre tartuga",
  "item.minecraft.tipped_arrow.effect.water": "Sageta d'aiga",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Sageta de respiracion aqüatica",
  "item.minecraft.tipped_arrow.effect.weakness": "Sageta de flaquesa",
  "item.minecraft.tipped_arrow.effect.weaving": "Sageta de Téisser",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Sageta de Buf",
  "item.minecraft.tnt_minecart": "Vagonet amb de TNT",
  "item.minecraft.torchflower_seeds": "Granas d'entòrcha-flor",
  "item.minecraft.totem_of_undying": "Totèm d'immortalitat",
  "item.minecraft.trader_llama_spawn_egg": "Uòu d'aparicion de lama ambulanta",
  "item.minecraft.trial_key": "Clau de las espròvas",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Peis tropicau",
  "item.minecraft.tropical_fish_bucket": "Peis tropicau dins un ferrat",
  "item.minecraft.tropical_fish_spawn_egg": "Uòu d'aparicion de peis tropicau",
  "item.minecraft.turtle_helmet": "Clòsca de tartuga",
  "item.minecraft.turtle_scute": "Placa de tartuga",
  "item.minecraft.turtle_spawn_egg": "Uòu d'aparicion de tartuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Ondradura dels vex",
  "item.minecraft.vex_spawn_egg": "Uòu d'aparicion de vex",
  "item.minecraft.villager_spawn_egg": "Uòu d'aparicion de vilatgés",
  "item.minecraft.vindicator_spawn_egg": "Uòu d'aparicion de vindicator",
  "item.minecraft.wandering_trader_spawn_egg": "Uòu d'aparicion de mercant ambulant",
  "item.minecraft.ward_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Ondradura dels abisses",
  "item.minecraft.warden_spawn_egg": "Uòu d'aparicion de warden",
  "item.minecraft.warped_fungus_on_a_stick": "Fonge bescornut sus un baston",
  "item.minecraft.water_bucket": "Ferrat d'aiga",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ondradura dels correires",
  "item.minecraft.wheat": "Blat",
  "item.minecraft.wheat_seeds": "Granas de blat",
  "item.minecraft.white_bundle": "Sac blanc",
  "item.minecraft.white_dye": "Tencha blanca",
  "item.minecraft.white_harness": "Arnesc blanc",
  "item.minecraft.wild_armor_trim_smithing_template": "Modèl de fargatge",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Ondradura salvatja",
  "item.minecraft.wind_charge": "Carga de vent",
  "item.minecraft.witch_spawn_egg": "Uòu d'aparicion de masca",
  "item.minecraft.wither_skeleton_spawn_egg": "Uòu d'aparicion d'esqueleta wither",
  "item.minecraft.wither_spawn_egg": "Uòu d'aparicion de wither",
  "item.minecraft.wolf_armor": "Amadura per lop",
  "item.minecraft.wolf_spawn_egg": "Uòu d'aparicion de lop",
  "item.minecraft.wooden_axe": "Pigassa en fusta",
  "item.minecraft.wooden_hoe": "Bigòs en fusta",
  "item.minecraft.wooden_pickaxe": "Trenca en fusta",
  "item.minecraft.wooden_shovel": "Pala en fusta",
  "item.minecraft.wooden_spear": "Wooden Spear",
  "item.minecraft.wooden_sword": "Espasa en fusta",
  "item.minecraft.writable_book": "Libre e pluma",
  "item.minecraft.written_book": "Libre Escrich",
  "item.minecraft.yellow_bundle": "Sac jauna",
  "item.minecraft.yellow_dye": "Tencha jauna",
  "item.minecraft.yellow_harness": "Arnesc jaun",
  "item.minecraft.zoglin_spawn_egg": "Uòu d'aparicion de zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Uòu d'aparicion de cavau zòmbi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombie Nautilus Spawn Egg",
  "item.minecraft.zombie_spawn_egg": "Uòu d'aparicion de zòmbi",
  "item.minecraft.zombie_villager_spawn_egg": "Uòu d'aparicion de zòmbi vilatgés",
  "item.minecraft.zombified_piglin_spawn_egg": "Uòu d'aparicion de piglin zombificat"
}
export const oc_fr = items; 
